{
  "(MitDiesemGeschäftGeschlossen)": "(Chiuso con questa attività)",
  "(mit Ertragswertkomponente)": "(con componente di valore reddituale capitalizzata)",
  "ABBRUCH": "Annullare",
  "ABGEBROCHEN": "Interrotto",
  "ABGESCHLOSSEN_MIT_GRUNDBUCH": "Completato con il registro fondiario",
  "ABGESCHLOSSEN_OHNE_GRUNDBUCH": "Completato senza registro fondiario",
  "ABGEWIESEN": "Respinto",
  "ABGEWIESEN_AUSGETRAGEN": "Respinto e scaricato",
  "ABSCHLUSS": "Chiusura",
  "ACI": "ACI",
  "ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER": "Campo, prato, giardino, orto",
  "ADG": "ADG",
  "ADG_lang": "Ancien droit genevois",
  "AHV-Nr/UID": "N. AVS / IDI",
  "AHVNummer": "N° AVS (precedente)",
  "AHVVersichertennummer": "N° AVS",
  "AKUTSPITAELER_ALLGEMEINE_SPITAELER": "Ospedali per acuti, ospedali generali",
  "ALLE": "Tutto",
  "ALLEINEIGENTUM": "Proprietà esclusiva",
  "ALLE_PERSON": "Tutto",
  "ALTRECHTLICH": "Vecchia legge",
  "AMWARTEN": "Eccezionale",
  "ANDERE": "altre osservazioni MU",
  "ANDEREADRESSE": "Altro indirizzo",
  "ANDEREART": "Altro genere",
  "ANDEREROLLE": "ruolo diverso",
  "ANDERE_BEHERBERGUNGEN": "Altri alloggi",
  "ANDERE_GEBAEUDE_FUER_DIE_KOLLEKTIVE_UNTERKUNFT": "Altri edifici per alloggi collettivi",
  "ANDERE_GEBAEUDE_FUER_KURZFRISTIGE_BEHERBERGUNGEN": "Altri edifici per alloggi di breve durata",
  "ANDERE_LANDWIRTSCHAFTLICHE_GEBAEUDE": "Altri edifici agricoli",
  "ANDERE_WOHNGEBAEUDE": "Altri edifici residenziali (edifici residenziali con uso accessorio)",
  "ANMERKUNG": "Menzione",
  "ANMERKUNG_KURZ": "ME",
  "ANREDE": "Titolo",
  "AUFGABE": "Compito",
  "AUFGEHOBEN": "Recuperato",
  "AUFGELOESTEPARTNERSCHAFT": "associazione sciolta",
  "AUSLAENDISCHE_GEMEINDE": "Comune straniero",
  "AUSLAENDISCHE_RECHTSFORM": "Forma giuridica straniera",
  "AV-Mutation": "Mutazione AV",
  "AV-Mutationsnummer": "Numero di mutazione",
  "AV_BEMERKUNG": "Osservazione MU",
  "AW": "VO",
  "AW: ": "AW: ",
  "Abbrechen": "Annulla",
  "Abbruchjahr": "Anno di demolizione",
  "Ablaufdatum": "Data di scadenza",
  "Abschluss (Rechtsgültigsetzung)": "Conclusione (convalida)",
  "Abschlussdatum": "Data di chiusura",
  "Abschnittflaeche": "Sezione",
  "AdminNr": "Admin no.",
  "AdminWohnungsnummer": "Admin. Numero di appartamento",
  "Adresse": "Indirizzo",
  "AdresseEingang": "Indirizzo / Ingresso",
  "AdresseKopieren": "Copiare l'indirizzo negli appunti",
  "AdresseWurdeKopiert": "L'indirizzo è stato copiato negli appunti",
  "Adressen": "Indirizzi",
  "AdressenAufbereiten": "Preparare gli indirizzi",
  "AdressenN": "Indirizzo/i",
  "AktenempfaengerFreitext": "Destinatario del file Testo libero",
  "Aktueller Betrachtungskontext": "Contesto attuale di considerazione",
  "Alle": "Tutto",
  "Alleineigentum": "Proprietà esclusiva",
  "Alpgrundstuecke": "Proprietà alpine",
  "AlteIdentifikation": "Vecchio ID (data, ID)",
  "AmtlicheBaudossiernummer": "Fascicolo ufficiale di costruzione n.",
  "AmtlicheBaudossiernummerZusatz": "Fascicolo ufficiale di costruzione n. Aggiunta",
  "AmtlicheBewertung": "Valutazione ufficiale",
  "AmtlicherWert": "Valore ufficiale",
  "AngefordertenRessourceWurdeNeueUriZugewiesen": "Alla risorsa richiesta è stato assegnato un nuovo URI permanente.",
  "Anmelder": "Persona dichiarata",
  "AnmelderText": "Dichiarare la persona Testo",
  "Anmerkung": "Menzione",
  "AnmerkungAmtlicheVermessung": "Osservazioni MU",
  "Anmerkungen": "Menzioni",
  "Anmerkungsgrundstueck": "Base di annotazione",
  "Annulliert": "Annullato",
  "Anrede": "Titolo",
  "Anteil": "Parte",
  "AnteilAmDominiertenGrundstueck": "Quota del comproprietà coattiva",
  "AnteilAmStammgrundstueck": "Quota della particella madre",
  "AnteilEigentum": "Quota di proprietà",
  "AnzahlGebaeude": "Numero di edifici interessati",
  "AnzahlGeschosse": "Numero di piani",
  "AnzahlWohnraeume": "Numero di soggiorni separati",
  "AnzahlWohnungen": "Numero di appartamenti",
  "AnzahlZimmer": "Numero di camere",
  "Anzeige": "Display",
  "AnzeigeBauprojekt": "Mostra i dettagli del progetto di costruzione",
  "AnzeigeGebäude": "Mostra i dettagli dell'edificio",
  "AnzeigeWohnung": "Mostra i dettagli dell'appartamento",
  "Art": "tipo",
  "ArtDerArbeiten": "Tipo di lavoro",
  "ArtDerBauwerke": "Tipo di strutture",
  "AufbereitungsoptionenEigentuemerAuszug": "Opzioni di elaborazione Estratto proprietario",
  "AufbereitungsoptionenGrundstueckAuszug": "Opzioni di elaborazione dell'estratto di fondo",
  "AufbereitungsoptionenRechteAuszug": "Opzioni di elaborazione Estrazione dei diritti",
  "Aufklappen": "aperto",
  "Auftraege": "Mandati",
  "Auftrag": "Mandato",
  "Auftrag senden": "Inviare l'ordine",
  "Auftrag.SucheTitel": "Ricerca mandati",
  "AuftragLoeschen": "Cancella ordine",
  "AuftragMitNummerErfolgreichErstellt": "L'ordine con il numero {{auftragsNummer}} è stato creato con successo",
  "AuftraggeberFreitext": "Testo libero del mandante",
  "Auftrags-Nr": "Numero di mandato",
  "AuftragsNr": "Numero di mandato",
  "AuftragsNummerAblage": "N. d'ordine / archiviazione",
  "AuftragsTyp": "Tipo di mandato",
  "Auftragsdatum": "Data dell'ordine",
  "Ausgang": "Uscita",
  "AusserbuchlicherUebergang": "Trasferimento fuori registro",
  "Auswahl": "Selezione",
  "Auszug": "Estratto",
  "AuszugBearbeiten": "Elaborare l'estratto",
  "AuszugErstellen": "Creare un estratto",
  "AuszugZuANMERKUNGErstellen": "Creare un estratto per il commento {{param}}",
  "AuszugZuDIENSTBARKEITErstellen": "Creare un estratto per la servitù {{param}}",
  "AuszugZuEIGENTUMANTEILErstellen": "Creare una dichiarazione sulla parte di proprietà {{param}}",
  "AuszugZuEigentuemerErstellen": "Creare la dichiarazione del proprietario su {{param}}",
  "AuszugZuGRUNDLASTErstellen": "Creare un estratto per il onere fondiario {{param}}",
  "AuszugZuGrundbuchmeldungErstellen": "Creare un estratto per la notifica al registro fondiario",
  "AuszugZuGrundstueckErstellen": "Creare un estratto per la proprietà {{param}}",
  "AuszugZuPFANDRECHTErstellen": "Creare un estratto per il pegno {{param}}",
  "AuszugZuRechtErstellen": "Creare l'estratto giusto {{param}}",
  "AuszugZuSDR_DIENSTBARKEITErstellen": "Estrazione in SDR Creazione di una servitù {{param}}",
  "AuszugZuVORMERKUNGErstellen": "Creare un estratto per l'annotazione {{param}}",
  "Auszüge": "Estratti",
  "AvBemerkung": "Osservazione MU",
  "AvMutation": "Mutazione AV",
  "BAHNANLAGEN": "Impianti ferroviari",
  "BAHNEN_STRASSEN_WEGE_BISHER": "Ferrovie, strade, sentieri",
  "BAHNHOEFE_ABFERTIGUNGSGEBAEUDE_FERNSPRECHVERMITTLUNGSZENTRALEN": "Stazioni ferroviarie, edifici terminali, centrali telefoniche",
  "BAUBEWILLIGUNG_BEWILLIGT": "Approvazione della domanda di costruzione",
  "BAUGESUCH_ABGELEHNT": "Domanda di costruzione respinta",
  "BAUGESUCH_BEANTRAGT": "Richiesta di applicazione dell'edificio",
  "BAURECHT": "Assegnare a: (fondo/i)",
  "BE-EDID": "BE-EDID",
  "BEARBEITET": "Modificato",
  "BEARBEITUNG": "In corso di trattamento",
  "BEFESTIGT_BAHN": "Ferrovia",
  "BEFESTIGT_FLUGPLATZ": "Campo d'aviazione",
  "BEFESTIGT_STRASSE_WEG": "Strada, sentiero",
  "BEFESTIGT_TROTTOIR": "Trottoir",
  "BEFESTIGT_UEBRIGE_BEFESTIGTE": "Altra area pavimentata",
  "BEFESTIGT_VERKEHRSINSEL": "Isola di traffico",
  "BEFESTIGT_WASSERBECKEN": "Bacino d'acqua",
  "BEHAELTER_SILOS_UND_LAGERGEBAEUDE": "Contenitori, silos ed edifici di stoccaggio",
  "BELASTET": "Caricato",
  "BELASTET_BERECHTIGT": "Incarichi/titoli di proprietà",
  "BERECHTIGT": "Autorizzato",
  "BEREINIGUNG": "Epurazione",
  "BEREITZURUEBERNAHME": "Pronti per l'acquisto",
  "BEREIT_FUER_GRUNDBUCH": "Pronto per il libro mastro",
  "BEREIT_FUER_KORREKTURLIEFERUNG": "Proto per correzione",
  "BEREIT_FUER_TAGEBUCH": "Pronto per il giornale",
  "BEREIT_FUER_VERARBEITUNG": "Proto per trattamento",
  "BEREIT_ZUR_VERIFIKATION": "Pronto per la verifica",
  "BERGWERK": "Miniera",
  "BERGWERK_ausg": "Miniera",
  "BESTEHEND": "Esistente",
  "BESTOCKT_GESCHLOSSENER_WALD": "Foresta chiusa",
  "BESTOCKT_UEBRIGE_BESTOCKTE": "Altra area di stoccaggio",
  "BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT": "Wytweide denso",
  "BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN": "Wytweide, aperto",
  "BEWERTUNGSGRUND": "Motivo della valutazione",
  "BEWILLIGT": "Approvato",
  "BODENBEDECKUNG": "Genere di coltura",
  "BUEROGEBAEUDE": "Edificio per uffici",
  "BUEROGEBAEUDE_VERWALTUNGSGEBAEUDE": "Edificio per uffici, edificio amministrativo",
  "BUS_TRAMANLAGEN": "Sistemi di autobus e tram",
  "Bauart": "Design",
  "Baueingabe": "Applicazione dell'edificio",
  "BaugesuchAbgelehnt": "Domanda di costruzione respinta",
  "BaugesuchBeantragt": "Richiesta di applicazione dell'edificio",
  "BaugesuchBewilligt": "Approvazione della domanda di costruzione",
  "Baujahr": "Anno di produzione",
  "Bauort": "Cantiere",
  "BauortMussVorhandenSein": "Il cantiere deve essere disponibile.",
  "Bearbeiter": "Responsabile",
  "Bearbeitet": "Modificato",
  "Bearbeitungsstatus": "Stato di elaborazione",
  "Belastet": "C",
  "BelastetBerechtigt": "OD",
  "BelastetMit": "Caricato con SDR",
  "BelastetOderBerechtigt": "Fondi gravati",
  "BelasteteTeilflaechen": "Superfici parziali gravate",
  "Belastung": "Carico",
  "Beleg": "Titolo giuridico",
  "BelegAlt": "Documento vecchio",
  "Belegamt": "Ufficio documenti",
  "Belegdatum": "Data di creazione",
  "BelegeZuGrundbuchgeschäft": "Documenti di supporto per le pratiche ",
  "Bemerkung": "Osservazione",
  "BemerkungGrundbuch": "Osservazioni",
  "Bemerkungen": "Osservazioni",
  "Berechtigt": "D",
  "BerechtigtAn": "Diritto a ",
  "BerechtigtePersonen": "Persone avente",
  "Bereinigungsmarkierung": "marcatura di revisione",
  "BereitFuerGrundbuch": "Data pronta per il registro fondiario",
  "BereitfürGrundbuch": "Pronto per il libro mastro",
  "Beschreibung": "Descrizione",
  "BeteiligteGrundstuecke": "Fondi coinvolti",
  "BetroffeneGebäude": "Edifici interessati",
  "BetroffeneGemeinden": "Comune interessate",
  "BetroffeneGrundstücke": "Fondi coinvolti",
  "Bewertung": "Valutazione",
  "Bezeichnung": "Denominazione",
  "BezugZumGrundbuch": "Riferimento al registro fondiario",
  "Bodenbedeckung": "Genere di coltura",
  "BodenbedeckungGeschichte": "Tenere conto della storia",
  "CFA": "CFA",
  "CFA_lang": "Costruzione",
  "CSV": "CSV",
  "Close": "Chiusura",
  "CodeGläubiger": "Codice creditore",
  "CodeNachRechtart": "Codice in base al tipo di legge",
  "CodeSchuldner": "Codice Debitore",
  "DEFAULT_MIT_GRUNDBUCH": "Con registro fondiario",
  "DEFAULT_OHNE_GRUNDBUCH": "Pratica standard senza registro fondiario",
  "DEFINITIV": "Definitivo",
  "DENKMAELER_ODER_UNTER_DENKMALSCHUTZ_STEHENDE_BAUWERKE": "Monumenti o edifici tutelati",
  "DIENSTBARKEIT": "servitù",
  "DIENSTBARKEIT_GRUNDLAST": "onere fondiario/motivazioni giuridiche",
  "DIENSTBARKEIT_KURZ": "SE",
  "DOMINANTINDENT": "INDIPENDENTE DOMINANTE",
  "DOMINANTINDET": "Dominantind",
  "DPI": "DPI",
  "DPI_lang": "Domaine public immatriculé",
  "DRINGEND": "urgente",
  "DarinEnthalteneZugaben": "Le aggiunte comprendono",
  "Dateiformat": "Formato del file",
  "Datenquelle": "Fonte dei dati",
  "Datenschutzbereinigt": "protezione dei dati",
  "Datum": "Data",
  "Datum Auftrag": "Data del mandato",
  "DatumAuftrag": "Data del mandato",
  "DatumBaubeginn": "Data di inizio costruzione",
  "DatumBaubewilligung": "Data del permesso di costruzione",
  "DatumBauende": "Data di fine costruzione",
  "DatumBis": "Data Fino a",
  "DatumDesExports": "Data di esportazione",
  "DatumEingabe": "Data di pubblicazione",
  "DatumEingabeFehler": "Il periodo per la data di pubblicazione non deve superare {{tage}} giorni.",
  "DatumEntstehung": "Data di creazione",
  "DatumEntstehungErgänzung": "Data (origine/supplemento)",
  "DatumJahrEingabeFormatBeispiel": "aaaa",
  "DatumMonatEingabeFormatBeispiel": "mm",
  "DatumNutzenUndGefahr": "Data utili e rischi",
  "DatumOderBeleg": "Data/documento",
  "DatumOderBelegOderEntstehung": "Data / Ricezione / Creazione",
  "DatumOderBelegOderRechtsgrund": "Data/Documento/Territorio legale",
  "DatumOderEntstehungOderRechtsgrund": "Data/Documento/Territorio legale",
  "DatumProjekteingabe": "Data della domanda di costruzione",
  "DatumRechtsgrund": "Data Titolo giuridico",
  "DatumTagEingabeFormatBeispiel": "tt",
  "DatumVertragsabschluss": "Data conclusione del contratto",
  "DatumVon": "Data Da",
  "DerServerMeldetEinenTechnischenFehler": "Il server segnala un errore tecnico (HTTP {{status}})",
  "Detaillierungsgrad": "Livello di dettaglio",
  "DetailsZuArtAnzeigen": "Mostra i dettagli di {{art}}",
  "DetailsZuGebaeudeWohnungsregister": "Dettagli Edificio, registro degli alloggi",
  "DetailsZuGrundstueckAusSichtGrundbuch": "Dettagli sulla proprietà dal registro fondiario",
  "DetailsZuGwrGebäude": "Dettagli dell'edificio REA",
  "DetailsZumGeschaeftAnzeigen": "Mostra i dettagli della pratica",
  "DetailsZumLöschgeschaeftAnzeigen": "Mostra i dettagli dell'attività di spegnimento",
  "Dienstbarkeit": "servitù",
  "DienstbarkeitDetail": "Dettaglio della concessione",
  "Dienstbarkeiten": "Servitù",
  "Dokumente": "Documenti",
  "DokumenteZuAlteGrundbuchmeldung": "Vecchia notifica del registro fondiario per le imprese {{param}}",
  "DokumenteZuBeleg": "Documenti per il voucher {{param}}",
  "DokumenteZuGeschaeft": "Documenti aziendali {{param}}",
  "DokumenteZuGrundstueck": "Documenti di proprietà {{param}}",
  "DokumenteZuRecht": "Documenti di diritto {{param}}",
  "DominantIndet": "*DI",
  "DominierendeGrundstuecke": "Fondi dominanti",
  "DominierteGrundstuecke": "Fondi serventi",
  "Dossiernummer": "Numero di file",
  "DossiernummerdSuche": "Numero del dossierCerca",
  "EBelege": "Documenti",
  "EDID": "EDID",
  "EGBPID": "EGBPID",
  "EGBTBID": "EGBTBID",
  "EGBTBIDSuche": "Ricerca EGBTBI",
  "EGID": "EGID",
  "EGID_EWID": "EGID / EWID",
  "EGRID": "E-GRID",
  "EGVAnmeldung": "Iscrizione eGV",
  "EIDGENOESSISCH": "Federale",
  "EIGENTUEMER": "Proprietari",
  "EINFACHEGESELLSCHAFT": "Società semplice",
  "EINFAMILIENHAEUSER": "Case unifamiliari",
  "EINFAMILIENHAEUSER_ANGEBAUT": "Case indipendenti attaccate",
  "EINFAMILIENHAEUSER_FREISTEHEND": "Case indipendenti",
  "EINFUEHRUNG": "Introduzione della RFD in corso",
  "EINGEDOLTES_GEWAESSER": "corso d'acqua con fossato",
  "EINMALIG": "Unico",
  "EINZELPFANDRECHT": "Diritto individuale di pegno",
  "EINZELPFANDRECHT_KURZ": "S",
  "ELEKTRIZITAETSWERKE_NETZE": "Impianti e reti elettriche",
  "EPROID": "EPROIDE",
  "ERBENGEMEINSCHAFT": "Comune ereditaria",
  "EREID": "EREID",
  "EROEFFNET": "Aperto",
  "ERSTERHEBUNG_ERNEUERUNG": "Prima elevazione/ rinnovo",
  "ERWERBER": "Acquirente",
  "EW": "VR",
  "EXMATRIKULIERT": "[I] Exmatrikuliert",
  "EXTERNER_HINWEIS": "Riferimento esterno",
  "EgbpidSuche": "Ricerca EGBPID",
  "EgbtbidSuche": "Ricerca EGBTBID",
  "EgidSuche": "Ricerca EGID",
  "EgridSuche": "Ricerca con E-GRID",
  "EgvtBelege": "Ricevute eGV",
  "Eigentuemer": "Proprietà",
  "Eigentum": "Proprietà",
  "EigentumErweitern": "Ampliare la proprietà",
  "EigentumExportieren": "Proprietà di esportazione",
  "Eigentumsform": "Eigentumsform",
  "Eigentumsform.ALLEINEIGENTUM": "Proprietà esclusiva",
  "Eigentumsform.GESAMTEIGENTUM": "Proprietà comune",
  "Eigentumsform.MITEIGENTUM": "Proprietà comune",
  "EigentümerBisher": "Precedentemente di proprietà di",
  "EigentümerMitAdresseAufbereiten": "Preparare i proprietari con l'indirizzo",
  "EigentümerNeu": "Di nuova proprietà di",
  "Eigentümerauszug": "Dichiarazione del proprietario",
  "EinTechnischerFehlerIstAufgetreten": "Si è verificato un errore tecnico.",
  "EingabeDarfNichtLeerSein": "L'ingresso non deve essere vuoto",
  "EingabeGemeindeErforderlich": "È richiesta l'iscrizione di un comune",
  "EingabeGrundbuchamtErforderlich": "È necessario l'apporto di un registro fondiario",
  "EingabeIstZuLange": "L'input è troppo lungo",
  "EingabeMussFolgendesFeldAngegebenHaben": "\"{{Feld}}\" deve essere specificato",
  "EingabeMussGenauEineGemeindeAusgewaehltHaben": "Deve essere selezionato esattamente un comune",
  "EingabeMussGueltigeHaunsummerSein": "L'input deve essere un numero civico valido (ad es. 2a).",
  "EingabeMussGueltigeStrasseSein": "L'input deve contenere almeno 2 caratteri",
  "EingabeMussJahrSein": "L'input deve essere un anno a 4 cifre",
  "EingabeMussMindestensEinGrundstueckTypAusgewaehltHaben": "Deve essere selezionato almeno un tipo di fondo",
  "EingabeMussMindestensEineBodenbedeckungAusgewaehltHaben": "È necessario selezionare almeno una copertura del suolo.",
  "EingabeMussMindestensEineGrundstueckbeschreibungHaben": "È necessario selezionare almeno una descrizione del fondo",
  "EingabeMussMindestensEinePersonenartAusgewaehltHaben": "Deve essere selezionato almeno un tipo di persona",
  "EingabeMussMindestensEineRechteArtAusgewaehltHaben": "Deve essere selezionato almeno un tipo di diritto",
  "EingabeMussMindestensEineRubrikAusgewaehltHaben": "Deve essere selezionata almeno una categoria",
  "EingabeMussValideAHVNummerSein": "L'ingresso deve essere un numero AVS valido",
  "EingabeMussValideBaudossiernummerSein": "L'input deve essere un numero di pratica di costruzione valido",
  "EingabeMussValideEgbpidSein": "L'input deve essere un EGBPID valido (ad esempio, CH123577617789).",
  "EingabeMussValideEgbtbidSein": "L'input deve essere un EGBTBID valido (ad esempio, CH123577617789).",
  "EingabeMussValideEgidSein": "L'ingresso deve essere un EGID valido",
  "EingabeMussValideEgridSein": "L'ingresso deve essere un E-GRID valido",
  "EingabeMussValideEmailSein": "L'input deve essere un'e-mail valida",
  "EingabeMussValideEproidSein": "L'ingresso deve essere un EPROID valido",
  "EingabeMussValideEreidSein": "L'ingresso deve essere un EREID valido",
  "EingabeMussValideGrundstueckNummerSein": "L'input deve essere un numero fondo valido",
  "EingabeMussValideNummerSein": "L'input deve essere un numero",
  "EingabeMussValideNummerSein-EGID": "L'input deve essere un numero. Attenzione: qui ci si aspetta un EGID (identificatore di edificio federale), non un E-GRID (identificatore di proprietà federale).",
  "EingabeMussValideNummerSein5Stellen>80k": "Per cercare i diritti speciali, è necessario inserire un numero a 5 cifre > 80000.",
  "EingabeMussValideNummerSeinBeispiel": "L'input deve essere un numero nella forma 2018",
  "EingabeMussValidePLZSein": "L'input deve essere un codice postale valido",
  "EingabeMussValideUIDSein": "L'ingresso deve essere un IDI valido",
  "EingabeMussValideVersicherungsNummerSein": "L'inserimento deve essere un numero di assicurazione valido",
  "EingabeMussValiderBaudossiernummerZusatzSein": "L'input deve essere un suffisso valido del numero di fascicolo di costruzione.",
  "EingabeMussValiderMonatSein": "Deve essere un mese valido",
  "EingabeMussValiderTagSein": "L'input deve essere un tag valido",
  "EingabeMussValidesDatumSeinBeispiel": "L'input deve essere una data nella forma 31.12.2018",
  "EingabeMussValidesJahrSein": "L'iscrizione deve essere un anno valido",
  "EingabeNichtValide(1-30Zeichen)": "L'input non è valido (deve contenere 1-30 caratteri)",
  "EingabeUploadFileNichtValidOderNameExistiert": "L'elenco non è formattato correttamente o il nome del file esiste già.",
  "Eingang": "Iscrizione",
  "Eingangsdatum": "Data di ingresso",
  "Einstellungen": "Impostazioni",
  "EinstellungenSpeichernBisZurNaechstenAbmeldung": "Salva le impostazioni (fino al prossimo logout)",
  "EinstellungenZuruecksetzen": "Ripristino delle impostazioni",
  "Eintraege": "Entrate",
  "Eintrag": "Data d'iscrizione",
  "Eintragung": "Registrazione",
  "EintragungenImGrundbuch": "Iscrizioni nel registro fondiario",
  "Einzelobjekt": "Oggetto singolo",
  "EinzelobjektAbkürzung": "EO",
  "Enddatum": "Data di fine",
  "EnthalteneZugaben": "Bis contenuto in esso",
  "Entschädigung": "Indennità",
  "EntstandenAus": "Creato da",
  "Entstehungsdatum": "Data di creazione",
  "EproidSuche": "EproidRicerca",
  "EreidSuche": "Ricerca EREID",
  "EreidsAufbereiten": "Preparare gli EREID",
  "ErgebnisoptionenEigentum": "Opzioni di risultato Proprietà",
  "ErgebnisoptionenGrundstueckbeschreibung": "Opzioni di risultato Descrizione del fondo",
  "ErgebnisoptionenStammperson": "Opzioni di risultato persona principale",
  "ErrorGettingMap": "Errore durante il caricamento del piano",
  "ErrorWhileLoading": "Si è verificato un errore durante l'elaborazione della query. È possibile che i dati visualizzati siano incompleti. Riprovare più tardi.",
  "Erstelldatum": "Data di creazione",
  "ErstelltMit": "Creato con",
  "ErstelltVon": "Creato da",
  "Ersterfassung": "Registrazione iniziale",
  "ErsterfassungÜbergeben": "Prima registrazione (trasmessa)",
  "Erweitert": "Esteso",
  "ErweiterteSuche": "Ricerca avanzata",
  "Erwerber": "Acquirente",
  "Erwerbsangaben": "Dettagli dell'acquisto",
  "Export": "Esportazione",
  "FAUSTPFANDGLAEUBIGER": "Impegnato",
  "FEHLERHAFT": "Fallito",
  "FEHLERLOS": "Successo",
  "FERNHEIZUNGSANLAGEN": "Sistemi di teleriscaldamento",
  "FLAECHENBERICHTIGUNG": "Correzione superficie di fondo",
  "FLUGVERKEHRSANLAGEN": "Strutture per il traffico aereo",
  "FLURNAME": "Nome locale",
  "FOLIO": "Foglio",
  "FOLIO_ausg": "Foglio",
  "FORSTWIRTSCHAFTSBAUTEN": "Edifici forestali",
  "FREIZEIT_TOURISMUSANLAGEN": "Strutture per il tempo libero e il turismo",
  "FUNKTION_BENUTZER": "Funzione Utente",
  "FehlerBeimAufrufDesWebservice": "Errore durante la chiamata al servizio web",
  "Fehlermeldungen": "Messaggi di errore",
  "Flaeche": "Superficie",
  "FlaecheNichtAusgeschieden": "Area non designata",
  "FlaecheWertquote": "Rapporto superficie/valore",
  "Flaechenanteile": "Quote dell'area DSP",
  "Flurname": "Nome locale",
  "Folio": "Foglio",
  "FormDerFuehrung": "Forma della tenuta",
  "FremdId": "ID straniero",
  "FremdeIdentifikation": "Identificazione esterna",
  "Fremdsystem": "Sistema esterno",
  "FremdsystemFehler": "Un sistema di terze parti non può al momento fornire dati per questa richiesta.",
  "FremdsystemNeskoFehler": "Si è verificato un errore durante la chiamata a Nesko AB.",
  "GARAGENGEBAEUDE": "Edificio adibito a garage",
  "GARAGEN_PARKPLAETZE_EINSTELLHALLEN_IM_ZUSAMMENHANG_MIT_WOHNGEBAEUDEN": "Autorimesse, posti auto, sale di parcheggio in connessione con edifici residenziali",
  "GASWERKE_NETZE_CHEMISCHE_ANLAGEN": "Impianti e reti di gas, impianti chimici",
  "GB_AUSZUG_LIG": "estratto del registro fondiario di proprietà",
  "GB_AUSZUG_MIT": "Estratto del registro fondiario di comproprietà",
  "GB_AUSZUG_SDR": "Estratto del registro fondiario SDR",
  "GB_AUSZUG_SEYBUCH": "Estratto del registro fondiario Seybuch",
  "GB_AUSZUG_STW": "Estratto del registro fondiario di proprietà per piani",
  "GB_DETAIL_PFANDRECHT": "Panoramica dei diritti di pegno",
  "GB_DETAIL_STANDARDRECHT": "Panoramica dei diritti Diritto standard",
  "GB_GEMEINDEKREIS": "Cerchio del registro fondiario",
  "GB_GEMEINDE_OHNEKREIS": "Comune del registro fondiario",
  "GB_UEBERSICHT_LIG": "Panoramica della proprietà Proprietà",
  "GB_UEBERSICHT_MIT": "Panoramica della proprietà Comproprietà",
  "GB_UEBERSICHT_SDR": "Panoramica della proprietà SDR",
  "GB_UEBERSICHT_STW": "Panoramica della proprietà Proprietà per piani",
  "GEBAEUDE": "Edificio",
  "GEBAEUDEKATEGORIE": "Categoria di edificio",
  "GEBAEUDEKLASSE": "Classe di costruzione",
  "GEBAEUDESTATUS": "Stato dell'edificio",
  "GEBAEUDE_FUER_DEN_PFLANZENBAU": "Edifici per la produzione di colture",
  "GEBAEUDE_FUER_DIE_TIERHALTUNG": "Edifici per l'allevamento di animali",
  "GEBAEUDE_FUER_KULTUR_UND_FREIZEITZWECKE": "Edifici per scopi culturali e ricreativi",
  "GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER": "Edificio, spazio in cortile, giardino, strutture",
  "GEBAEUDE_MIT_AUSSCHLIESSLICHER_WOHNNUTZUNG": "Edifici a uso esclusivamente residenziale",
  "GEBAEUDE_MIT_DREI_ODER_MEHR_WOHNUNGEN": "Edifici con tre o più appartamenti",
  "GEBAEUDE_MIT_EINER_WOHNUNG": "Edificio con un appartamento",
  "GEBAEUDE_MIT_TEILWEISER_WOHNNUTZUNG": "Edificio con parziale uso residenziale",
  "GEBAEUDE_MIT_ZWEI_WOHNUNGEN": "Edificio con due appartamenti",
  "GEBAEUDE_OHNE_WOHNNUTZUNG": "Edifici senza uso residenziale",
  "GEBAUT": "Costruito",
  "GEBUEHR": "Tassa",
  "GEMEINDERSCHAFT": "Indivisione",
  "GEMEINDESTRASSEN": "Strade comunali",
  "GEMEINSCHAFT": "Comunità",
  "GEO_LINK": "GeoLink",
  "GESAMTEIGENTUM": "Proprietà comune",
  "GESAMTPFANDRECHT": "Diritto di pegno collettivo",
  "GESAMTPFANDRECHT_KURZ": "C",
  "GESAMTTEILPFANDRECHT": "Totale pegno parziale",
  "GESAMTTEILPFANDRECHT_KURZ": "CP",
  "GESCHAEFT_BESCHREIBUNG": "Descrizione",
  "GESCHIEDEN": "Divorziato",
  "GESELLSCHAFTSFORM": "Tipo di società",
  "GESETZLICHES_PFANDRECHT": "Diritto legale di pegno",
  "GEWAESSER_BISHER": "Acque",
  "GEWAESSER_FLIESSENDES": "Acqua corrente",
  "GEWAESSER_SCHILFGUERTEL": "Cinghia di canne",
  "GEWAESSER_STEHENDES": "Acqua stagnante",
  "GLAEUBIGER": "Creditore",
  "GLAEUBIGER_ROLLE": "Creditore",
  "GLAEUBIGER_SCHULDNER": "Creditore - Debitore",
  "GROSS_UND_EINZELHANDELSGEBAEUDE": "Edifici per la vendita all'ingrosso e al dettaglio",
  "GRUNDBUCH": "Registro fondiario",
  "GRUNDBUCH_ABGESCHLOSSEN": "Registro fondiario completato",
  "GRUNDLAST": "onere fondiario/motivazioni giuridiche",
  "GRUNDLAST_KURZ": "OF",
  "GRUNDPFANDGLAEUBIGER": "creditore con pegno immobiliare",
  "GRUNDPFANDVERSCHREIBUNG": "Ipoteca",
  "GRUNDSTUECK_UNTER_ART_LIG": "Sottotipo di proprietà",
  "GRUNDSTUECK_UNTER_ART_SDR": "Sottotipo SDR",
  "GUELT": "R",
  "GUETERGEMEINSCHAFT": "Comunione di beni",
  "GWRBAUPERIODE_8011": "Periodo precedente al 1919",
  "GWRBAUPERIODE_8012": "Periodo dal 1919 al 1945",
  "GWRBAUPERIODE_8013": "Periodo dal 1946 al 1960",
  "GWRBAUPERIODE_8014": "Periodo dal 1961 al 1970",
  "GWRBAUPERIODE_8015": "Periodo dal 1971 al 1980",
  "GWRBAUPERIODE_8016": "Periodo dal 1981 al 1985",
  "GWRBAUPERIODE_8017": "Periodo dal 1986 al 1990",
  "GWRBAUPERIODE_8018": "Periodo dal 1991 al 1995",
  "GWRBAUPERIODE_8019": "Periodo dal 1996 al 2000",
  "GWRBAUPERIODE_8020": "Periodo dal 2001 al 2005",
  "GWRBAUPERIODE_8021": "Periodo dal 2006 al 2010",
  "GWRBAUPERIODE_8022": "Periodo dal 2011 al 2015",
  "GWRBAUPERIODE_8023": "Periodo dal 2016",
  "GWRBauprojekt": "Progetto di costruzione REA",
  "GWRBauprojekte": "Progetti di costruzione REA",
  "GWRGebaeude": "Edificio REA",
  "GWRWohnung": "Appartamento REA",
  "GbBemerkung": "Commento AR",
  "Gbgeschäfte": "Iscrizioni a giornale",
  "Gebaeude": "Edificio",
  "Gebaeude-Nr.": "Edificio n.",
  "GebaeudeAdresse": "Edificio - Indirizzo",
  "Gebaeude_Einzahl": "Edificio",
  "Gebaeudebezeichnung": "Designazione dell'edificio",
  "Gebaeudeflaeche": "Area dell'edificio",
  "Gebaeudeschatzung": "Valutazione dell'edificio",
  "Gebaut": "Costruito",
  "Geburtsdatum": "Data di nascita",
  "GeburtsdatumGruendungsdatumaktivVon": "Data di nascita / data di fondazione / attivo da",
  "GeburtsdatumJahr": "Data di nascita Anno",
  "GeburtsdatumMonat": "Data di nascita Mese",
  "GeburtsdatumTag": "Data di nascita Giorno",
  "Gebäude/Bauten": "Edifici/costruzioni",
  "GebäudeVersicherungsNummer": "Edificio-Vers. No.",
  "GebäudeeingangsadresseAdressen": "Indirizzo dell'ingresso dell'edificio",
  "GefundeneBauprojekte": "Trovati progetti di costruzione REA",
  "GefundeneGebäude": "Edifici trovati",
  "GefundenePersonen": "Trovato {{rolle}}",
  "GefundeneRechte": "Diritti trovati",
  "GeloeschteGrundstuecke": "Proprietà cancellate",
  "GemaessGrundbuch": "Secondo il registro fondiario",
  "Gemeinde": "Comune",
  "Gemeinde.Kuerzel": "Abbreviazione",
  "GemeindeAuswahl": "Selezione del comune",
  "GemeindeEntfernen": "Rimuovere la Comune",
  "GemeindeMussVorhandenSein": "È necessario inserire un comune",
  "Gemeinden": "Comune",
  "Geogeschäfte": "Operazioni del geometra",
  "Geometergeschaeft.detail.VermarkungZurueckgestellt": "Marcatura posticipata",
  "GeometergeschaeftNummer": "Numero di attività del geometra",
  "Geometergeschaefte": "Iscrizioni misurazione ufficiale",
  "Geometergeschaeftszustand.BEARBEITUNG": "In corso di trattamento",
  "Geometergeschaeftszustand.BEREIT_FUER_GRUNDBUCH": "Pronto per il libro mastro",
  "Geometergeschaeftszustand.BEREIT_FUER_KORREKTURLIEFERUNG": "Proto per correzione",
  "Geometergeschaeftszustand.BEREIT_FUER_VERARBEITUNG": "Proto per trattamento",
  "Geometergeschaeftszustand.BEREIT_ZUR_VERIFIKATION": "Pronto per la verifica",
  "Geometergeschaeftszustand.EROEFFNET": "Aperto",
  "Geometergeschaeftszustand.RECHTSGUELTIG_ABGESCHLOSSEN": "Chiusura valida",
  "Geometergeschaeftszustand.RECHTSGUELTIG_VOLLZOGEN": "[D] Rechtsgültig vollzogen",
  "Geometergeschaeftszustand.RUECKMUTIERT_ABGESCHLOSSEN": "Mutazione annulata",
  "Geometergeschaeftszustand.VERKNUEPFT_MIT_GRUNDBUCH": "collegato con registro fondiario",
  "Geometergeschaeftszustand.WARTEN_AUF_VORGAENGER": "In attesa dell'iscrizione precedente",
  "Geometergeschaeftszustand.ZURUECK_ABGEWIESEN": "Rifiutato del registro fondiario",
  "Geometergeschaeftszustand.ZURUECK_ZURUECKGEZOGEN": "Ritirato dal registro fondiario",
  "Geometergeschaeftszustand.ZURUECK_ZUR_KORREKTUR": "Ritorno per correzione",
  "Geometergeschäft": "Pratica del geometra",
  "Gesamteigentum": "Proprietà comune",
  "Gesamtfläche": "Area totale",
  "Gesamtpreis": "Valore totale",
  "Gesamtwert": "Valore complessivo",
  "Geschaeftdetails": "Dettaglio della pratica",
  "GeschichteAnzeigen": "Mostra la storia",
  "Geschlecht": "Sesso",
  "GeschlossenAm": "Chiuso il",
  "Geschäftsstatus": "Stato della pratica",
  "Geschäftstyp": "Tipo di pratica",
  "Gesellschaftsform": "Tipo di società",
  "GesetzlichesPfandrecht": "Diritto legale di pegno",
  "GestrichenMit": "Cancellato con",
  "Glaeubiger": "Creditore",
  "GlaeubigerGlaeubigerinVon": "Creditore di ",
  "Gläubiger": "Creditore",
  "Grundbuch": "Registro fondiario",
  "GrundbuchMeldungZip": "Notifica del registro fondiario.zip",
  "Grundbuchamt": "Ufficio del registro fondiario",
  "Grundbuchgemeinde": "Comune del registro fondiario",
  "Grundbuchgeschaeft": "Pratica del registro fondiario",
  "Grundbuchgeschäft": "Pratica del registro fondiario",
  "Grundbuchgeschäfte": "Iscrizioni a giornale",
  "GrundbuchmeldungZuTagebuch": "Notifica del registro fondiario per agenda",
  "Grundbuchperson": "Persona del registro fondiario",
  "Grundbuchpläne": "Piani del registro fondiario",
  "Grundbuchtyp": "Tipo di registro fondiario",
  "Grundgueterschaetzung": "Tesoreria dei beni di base",
  "Grundlast": "onere fondiario/motivazioni giuridiche",
  "Grundlasten": "Oneri fondiari",
  "Grundpfandrecht": "Diritto di pegno fondiario",
  "Grundpfandrechtart": "Tipo di pegno immobiliare",
  "Grundpfandrechte": "Diritti di pegno",
  "Grundpfandrechtform": "Modulo di pegno immobiliare",
  "Grundstueck": "Registro fondi",
  "GrundstueckArt": "GrundstueckArt",
  "GrundstueckKopf.Label.Gemeinde": "Comune (n° UST)",
  "GrundstueckMitAenderungen": "Proprietà con modifiche",
  "GrundstueckMitFolgendenBodenbedeckungen": "Fondo con le seguenti coperture del suolo",
  "GrundstueckNummer": "Numero fondo",
  "Grundstueckbeschreibung": "Descrizione del fondo",
  "Grundstuecke": "Fondo/i",
  "Grundstuecksart": "Tipo di fondo",
  "Grundstück": "Fondo",
  "GrundstückGrundstücke": "Fondo/i",
  "GrundstückKopie": "Copia",
  "GrundstückPerson": "Proprietà/persona",
  "Grundstückbeschreibung": "Descrizione del fondo",
  "Grundstücke": "Fondi",
  "Gruppe": "Gruppo",
  "Gueltig": "Valido",
  "GueltigeDateiAuswaehlen": "Selezionare un file valido",
  "Gültig": "Valido",
  "HAENGIGE": "In attesa",
  "HAUPTBUCH": "Libro mastro",
  "HAUPTBUCH_ABGESCHLOSSEN": "Libro mastro concluso",
  "HEIME_MIT_UNTERKUNFT_PFLEGEDIENSTE_BETREUUNG": "Case con alloggio, servizi di cura e/o assistenza",
  "HERRENLOS": "Senza padrone",
  "HOCHBAU": "Ingegneria strutturale",
  "HOEHERES_BILDUNGSWESEN_FORSCHUNG": "Istruzione superiore e ricerca",
  "HOMONYME": "Omonimo",
  "HOTELGEBAEUDE": "Edificio alberghiero",
  "HOTELS_RESTAURANTS": "Hotel, Ristoranti",
  "HUMUSIERT_ACKER_WIESE_WEIDE": "Campo, prato, pascolo",
  "HUMUSIERT_GARTENANLAGE": "Area giardino",
  "HUMUSIERT_HOCH_FLACHMOOR": "Torbiera alta, palude",
  "HUMUSIERT_INTENSIVKULTUR_REBEN": "Viti a coltura intensiva",
  "HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR": "Altre colture intensive",
  "HUMUSIERT_UEBRIGE_HUMUSIERTE": "Area di humus rimanente",
  "HaengigeGeschaefte": "MaggioreAzienda",
  "HaengigeGeschaefteAufbereiten": "Elaborare l'iscrizioni pendenti",
  "HaengigeGeschaefteAufträge": "Transazioni/mandati in sospeso",
  "Handelsangaben": "Dati commerciali",
  "Haus-Nr.": "Casa no.",
  "Header": "Intestazione",
  "Heimatort": "Luogo d'origine",
  "Hinweis": "Nota",
  "HinweismeldungAuszuege": "È possibile stampare solo 20 estratti conto alla volta",
  "Historisiert": "Storicizzato",
  "Hängig": "In attesa",
  "HängigeAufträge": "Mandati in sospeso",
  "HängigeGbgeschäfte": "Iscrizioni del registro fondiario pendenti",
  "HängigeGeogeschäfte": "Iscrizioni del geometra pendenti",
  "HängigeGeschäfte": "Iscrizioni pendenti",
  "ID-DatumOderBelegOderRechtsgrund": "ID, data/documento/titolo giuridico",
  "IMARBEIT": "In corso",
  "IM_BAU": "In costruzione",
  "INDUSTRIEGEBAEUDE": "Edificio industriale",
  "INEINGETRAGENERPARTNERSCHAFT": "in unione registrata",
  "INHABER": "al portatore",
  "INHABER_PFANDRECHT_ART": "Carta al portatore.{{pfandrechtArt}}",
  "INHABER_PFANDRECHT_ART_PAPIER": "{{pfandrechtArt}} ipoteca su titolo al portatore",
  "IcpPrintException": "Si è verificato un errore imprevisto durante la preparazione della dichiarazione.",
  "InEinemDokumentDrucken": "Stampa in un documento",
  "Index": "Index",
  "Index1-2": "Indice 1-2",
  "Index1-3": "Indice 1-3",
  "Inhalt": "Contenuto",
  "JA": "Sì",
  "JURISTISCHE_PERSON": "Persona giuridica",
  "Ja": "Sì",
  "JaAmDatumDurchAnmelder": "Sì. Su {{datum}} da {{anmelder}}",
  "Jahr": "Anno",
  "JuristischePerson": "Persona giuridica",
  "KANTONAL": "Cantonale",
  "KANTONSSTRASSEN": "Strade cantonali",
  "KAUFHAEUSER_GESCHAEFTSGEBAEUDE": "Grandi magazzini, edifici commerciali",
  "KEHRICHTENTSORGUNGSANLAGEN": "Impianti di smaltimento dei rifiuti",
  "KENNZEICHNUNG_GEO_GESCHAEFT": "Pratica del geometra",
  "KIRCHEN_SAKRALBAUTEN": "Chiese ed edifici sacri",
  "KIRCHEN_UND_SONSTIGE_KULTGEBAEUDE": "Chiese e altri edifici di culto",
  "KOMMUNIKATIONSANLAGEN": "Sistemi di comunicazione",
  "KONZESSION": "Concessione",
  "KRANKENHAEUSER_UND_FACHEINRICHTUNGEN_DES_GESUNDHEITSWESENS": "Ospedali e strutture sanitarie specializzate",
  "KULTURBAUTEN_MUSEEN_BIBLIOTHEKEN_DENKMAELER": "Edifici culturali, compresi musei, biblioteche e monumenti",
  "KantGid": "Kant-GID",
  "KantonalePersonenID": "ID personale cantonale",
  "Katasternummer": "Numero del catasto",
  "Keine": "Nessuna",
  "KeineBerechtigungFuer": "Nessuna autorizzazione per {{inputField}}",
  "KeineBerechtigungFürDieseAktion": "Non avete l'autorizzazione per questa azione.",
  "KeineBzwGemaessGrundbuch": "Nessuno o secondo il registro fondiario",
  "KeineDatenVorhanden": "Nessun dato disponibile",
  "KeineResultateGefunden": "Non sono state trovate voci corrispondenti.",
  "Komponenten": "Componenti",
  "KuecheVorhanden": "Cucina disponibile",
  "Kuhrechte": "Diritti sulle vacche da macello",
  "Kurzbeschreibung": "Breve descrizione",
  "KurzdeklarationBeilage": "Dichiarazione breve come allegato",
  "LAGEFIXPUNKT": "Posizione punto fisso",
  "LAGERHALLEN_DEPOTS_SILOS_ZISTERNEN": "Magazzini, depositi, silos e cisterne",
  "LANDESVERTEIDIGUNGSBAUTEN": "Edifici della difesa nazionale",
  "LANDUMLEGUNG": "Modificazione di confini",
  "LANDWIRTSCHAFTLICHE_BETRIEBSGEBAEUDE": "Edifici agricoli di fattoria",
  "LANDWIRTSCHAFTSBAUTEN": "Edifici agricoli",
  "LEDIG": "Singolo",
  "LEEREPFANDSTELLE": "Posto di pegno libero",
  "LIEGENSCHAFT": "Bene immobile",
  "LIEGENSCHAFT_ausg": "Bene immobile",
  "LIG": "B-I",
  "LR": "OD",
  "LageAufStockwerk": "Posizione sul pavimento",
  "LageStockwerk": "Posizione sul piano",
  "Lagebezeichnung": "Ubicazione",
  "Last": "Onere",
  "LastRechtAbkürzung": "OD",
  "LastetAuf": "Carichi su",
  "Ledigname": "Nome da celibe/nubile",
  "LetzterEntgeltlicherErwerb": "UltimoPagamentoAcquisito",
  "Liegenschaft": "Bene immobile",
  "Link": "Collegamento",
  "Loading": "I dati vengono caricati...",
  "Loeschbeleg": "C",
  "Login": "Accesso",
  "Logout": "Disconnessione",
  "Löschen": "Cancellare",
  "Löschgeschäft": "Attività di cancellazione",
  "MAENNLICH": "Maschile",
  "MEHRFAMILIENHAEUSER": "Edifici per appartamenti",
  "MEHRFAMILIENHAEUSER_REINE_WOHNGEBAEUDE_MIT_MEHREREN_WOHNUNGEN": "Edifici di appartamenti (edifici puramente residenziali con più appartamenti)",
  "MELIORATIONEN": "Meliorations",
  "MH": "IM",
  "MIT": "COP",
  "MITEIGENTUM": "COP",
  "MITEIGENTUM_ausg": "COP",
  "MONATLICH": "Mensile",
  "MUSEEN_BIBLIOTHEKEN": "Musei / Biblioteche",
  "MarkiereAlsBearbeitet": "Contrassegnare come modificato",
  "MarkiereAlsNichtBearbeitet": "Contrassegnare come non modificato",
  "MaximalResultWarning": "Risultato incompleto perché sono state trovate troppe voci. Si prega di limitare la ricerca. Il numero massimo di voci è {{maxDisplayableRecords}}, sono state trovate {{recordsFound}}.",
  "MaximalResultWarningKeineEinschraenkung": "Risultato incompleto perché sono state trovate troppe voci. Il numero massimo di voci è {{maxDisplayableRecords}}, è stato trovato {{recordsFound}}.",
  "Maximalhypothek": "Ipoteca massima",
  "Maximalzinsfuss": "Tasso di interesse massimo",
  "MehrAnzeigen": "Mostra di più",
  "Mehrgeschossig": "Multipiano",
  "Meldung": "Avviso",
  "MeldungBearbeitet": "Messaggio modificato",
  "MeldungenAlsZip": "Esportazione in formato PDF (zippato)",
  "MeldungsId": "ID messaggio",
  "Meldungsempfaenger": "Destinatario del messaggio",
  "Mit": "con",
  "MitAciIroleNr": "con nessun ACI/IROLE",
  "MitAdresse": "Con indirizzo",
  "MitGebäuden": "Con edifici",
  "MitGrundbuchbezug": "Con riferimento al registro fondiario",
  "MitSonderrechten": "Con diritti speciali",
  "Miteigentumsanteil": "Quota di comproprietà",
  "MizenNichtErreichbar": "Impossibile raggiungere il centro messaggi (HTTP 401)",
  "Monat": "Mese",
  "Mutationsart": "Tipo di mutazione",
  "NACHRUECK_RECHT": "Diritto di subentro",
  "NAMEN": "nominativo",
  "NAMEN_PFANDRECHT_ART": "Nomi-Carta-{{pfandrechtArt}}",
  "NAMEN_PFANDRECHT_ART_PAPIER": "{{pfandrechtArt}} ipoteca su titolo nominativo",
  "NATIONALSTRASSEN": "Strade nazionali",
  "NATUERLICHE_PERSON": "Persona fisica",
  "NATURDENKMAL": "Monumento naturale",
  "NB-Ident": "NB-Ident",
  "NEIN": "No",
  "NEUBAU": "Nuovo edificio",
  "NICHTBEARBEITET": "Non elaborato",
  "NICHT_NUTZBAR": "Non utilizzabile",
  "NICHT_REALISIERT": "Non realizzato",
  "NORMAL": "normale",
  "NUTZNIESSER": "Beneficiario",
  "Nachrueckungsrecht": "Diritto di subentro",
  "Nachrückungsrecht": "Diritto di subentro",
  "Name": "Cognome",
  "Name/Bezeichnung1": "Nome / Designazione 1",
  "NameDerEltern": "Cognome dei genitori",
  "NameEhegatte": "Cognome del coniuge",
  "NameOderFirma": "Nome/Azienda",
  "Nationalitaet": "Nazionalità",
  "NatuerlichePerson": "Persona fisica",
  "Nein": "No",
  "NichtBearbeitet": "Non elaborato",
  "NichtOeffentlicheBemerkung": "Osservazioni interne",
  "NonBreakingSpace": " ",
  "NotAvailable": "n/a",
  "NotEnoughChars": "Non abbastanza caratteri",
  "Nummer": "Numero",
  "NurOeffentlicheAnmerkungenWerdenAngezeigt": "Solo menzioni pubbliche ai sensi dell'art. 26 cpv. 1 lett. c dell'Ordinanza sul registro fondiario. Altri diritti secondo il registro fondiario.",
  "NurZentraleId": "Solo ID centrale",
  "OEFFENTLICHE_KOERPERSCHAFT": "Ente pubblico",
  "ORTSNAME": "Nome del luogo",
  "Oberirdisch": "Fuori terra",
  "Objekt-Nr.": "Oggetto n.",
  "Objektbezeichnung": "Designazione dell'oggetto",
  "Objektcode": "Codice oggetto",
  "OeffentlichRechtlicheKoerperschaft": "Ente pubblico",
  "Oereb": "PLR-cadastre",
  "Ohne": "Senza",
  "Ort": "Luogo",
  "Ortschaft": "Località",
  "PARKHAEUSER": "Parcheggi",
  "PARTERRE": "Piano terra incl. mezzanino",
  "PERSONEN_GRUPPE": "Gruppo di persone",
  "PFANDOBLIGATION": "Obbligazione ipotecaria",
  "PFANDRECHT": "Diritto di pegno",
  "PFANDRECHT_BEMERKUNG": "Osservazione sul pegno",
  "PFANDRECHT_KURZ": "CF",
  "PROJEKT": "Progetto",
  "PROJEKTIERT": "progettati",
  "PROJEKT_ABGESCHLOSSEN": "Progetto completato",
  "PROJEKT_BAUBEGONNEN": "Progetto avviato",
  "PROJEKT_NICHT_REALISIERT": "Progetto non realizzato",
  "PROJEKT_SISTIERT": "Progetto sospeso",
  "PROJEKT_ZURUECKGEZOGEN": "Progetto ritirato",
  "PROVISORISCH": "Provvisorio",
  "PROVISORISCHE_UNTERKUNFT": "Alloggio temporaneo",
  "PROVISORISCH_ABGEWIESEN": "Respinto provvisoriamente",
  "Perimeter": "Perimetro",
  "Personalien": "Dati personali",
  "Personart": "Tipo di persona",
  "Personengruppe": "Gruppo di persone",
  "Personenregister": "Registro delle persone",
  "PersonstammVollstaendig": "Completo",
  "PfandrechtDetail": "Dettaglio del pegno",
  "PfandrechtGläubiger": "Creditore di pegno",
  "PfandrechtIdsAufbereiten": "Preparare gli ID dei diritti di pegno",
  "Pfandrechtbelastungen": "Aggravi del diritto di pegno",
  "Pfandrechtgläubiger": "Creditore di pegno",
  "Pfandrechtschuldner": "Debitore del pegno",
  "Pfandstelle": "Rango",
  "Pfandsumme": "Importo del pegno",
  "Pfandtitel": "Titolo",
  "Plan": "Piano",
  "PlanZuGrundstueckAnzeigen": "Mostra la planimetria della parcella {{param}}",
  "PlzOderOrtschaft": "Codice postale, località",
  "PlzOrt": "NPA/località",
  "Preis": "Valore",
  "ProjektAbgeschlossen": "Progetto completato",
  "ProjektBaubegonnen": "Progetto avviato",
  "ProjektNichtRealisiert": "Progetto non realizzato",
  "ProjektSistiert": "Progetto sospeso",
  "ProjektZurueckgezogen": "Progetto ritirato",
  "Projektiert": "progettati",
  "ProjektiertStatus": "Stato progetto",
  "ProjektierteGebaeudeWohnungen": "Edifici / appartamenti in progetto",
  "Projektmutation": "(mutazione del progetto)",
  "Projektstatus": "Stato del progetto",
  "Projektumschreibung": "Descrizione del progetto",
  "Protokollnummer": "Protocollo",
  "Publikationsdatum": "Data di pubblicazione",
  "QUALITAET_FLAECHE": "Qualità della superficie",
  "QUELLENRECHT": "Diritto di sorgente",
  "QualitaetAV": "Qualità standard MU",
  "QualitaetAV.AV93": "MO93",
  "QualitaetAV.GRAFISCH": "grafico",
  "QualitaetAV.PN": "[D] PN",
  "QualitaetAV.PN_DEFINITIV": "[D] PN riconosciuto definitivo",
  "QualitaetAV.PN_PROVISORISCH": "[D] PN riconosciuto provvisorio",
  "QualitaetAV.UNVERMESSEN": "senza misurazione",
  "REBEN_BISHER": "Viti",
  "RECHNUNGSADRESSE": "Indirizzo della fattura",
  "RECHTSDOMIZIL": "Domicilio legale",
  "RECHTSFORM": "Forma giuridica",
  "RECHTSGRUND": "Titolo giuridico",
  "RECHTSGUELTIG": "Valido",
  "RECHTSGUELTIG_ABGESCHLOSSEN": "Chiusura valida",
  "RECHTSGUELTIG_AUSGETRAGEN": "Valido e scaricato",
  "RECHTSGUELTIG_VOLLZOGEN": "[D] Rechtsgültig vollzogen",
  "REFERENZADRESSE": "Indirizzo di riferimento",
  "REGISTERSCHULDBRIEF": "Cartella ipotecaria di registro",
  "REKURS": "Ricorso",
  "REKURS_AKZEPTIERT": "Ricorso accettato",
  "RESTAURANTS_UND_BARS_IN_GEBAEUDEN_OHNE_WOHNNUTZUNG": "Ristoranti e bar in edifici senza uso residenziale",
  "RF": "RF",
  "RUECKMUTIERT_ABGESCHLOSSEN": "Mutazione annulata",
  "RUNDUNGSDIFFERENZ": "Differenza di arrotondamento",
  "Recht": "Diritto",
  "Rechtart": "Tipo di legge",
  "RechteId": "ID diritti",
  "Rechtsform": "Forma giuridica",
  "Rechtsgrund": "Titolo giuridico",
  "RechtsgrundArt": "tipo",
  "Rechtsgültig": "Valido",
  "Region": "Regione",
  "RegistraturText": "Testo del registro",
  "Renovationsjahr": "Anno di ristrutturazione",
  "Rolle": "Ruolo",
  "RolleGläubiger": "Ruolo creditore",
  "Rubrik": "Categoria",
  "Rubriken": "Rubriche",
  "RueckmeldungGrundbuch": "Data risposta RF",
  "SCHIFFSVERKEHRSANLAGEN": "Strutture per il traffico navale",
  "SCHULDBRIEF": "Cartella ipotecaria",
  "SCHULDNER": "Debitore",
  "SCHULDNER_ROLLE": "Debitore",
  "SCHULEN_BILDUNGSWESEN_BIS_MATURASTUFE": "Scuole, istruzione (fino al livello di maturità)",
  "SCHUL_UND_HOCHSCHULGEBAEUDE_FORSCHUNGSEINRICHTUNGEN": "Edifici scolastici e universitari, strutture di ricerca",
  "SCHWEIZERISCHE_JURISTISCHE_PERSON": "Persona giuridica svizzera",
  "SDR": "DSP",
  "SDR_DIENSTBARKEIT": "Cedolare SDR",
  "SDR_DIENSTBARKEIT_KURZ": "DI (SDR)",
  "SDR_ausg": "Diritto per sé stante e permanente",
  "SEYBUCH": "Seybuch",
  "SONDERBAU": "Costruzione speciale",
  "SONSTIGE_HOCHBAUTEN": "Altri edifici non classificati altrove",
  "SPORTHALLEN": "Palazzetti dello sport",
  "SPORTHALLEN_SPORTPLAETZE": "Palazzetti dello sport e campi sportivi",
  "SPRACHE": "Lingua",
  "STANDARD": "Standard",
  "STOCK": "Stock",
  "STOCKWERK": "Proprietà per piani",
  "STOCKWERK_ausg": "Proprietà per piani",
  "STORNIERT": "Annullato",
  "STR": "STR",
  "STRASSE": "Via",
  "STRASSE_WEG_TROTTOIR_RAV": "Strada, sentiero, marciapiede, spartitraffico",
  "STREITIGE_GRENZE": "Confine conteso",
  "STR_lang": "Strada parcellare",
  "STW": "PPP",
  "SUSPENDIERT": "Sospeso",
  "Schliessen": "Chiusura",
  "SchnellSuche": "Ricerca rapida",
  "Schuldner": "Debitore",
  "SchuldnerSchuldnerinVon": "Debitore da ",
  "SchulduebernahmeTotal": "Assunzione di debito totale",
  "SelbststaendigUndDauerndeRechte": "Diritti indipendenti e permanenti",
  "SelbststaendigesUndDauerndesRechtMitAbkuerzung": "Diritto per sé stante e permanente (DSPS)",
  "SelbstständigesUndDauerndesRecht": "Diritto per sé stante e permanente",
  "Select date": "Selezionare la data",
  "Servitute": "Servitù",
  "ServitutenregisterNr": "Registro di servitù n.",
  "Sitz": "Sede",
  "SonderpreisZugabe": "Valore speciale per i bis",
  "SonderpreisZugaben": "Valore speciale per i bis",
  "Sonderrecht": "Diritto esclusivo",
  "Sonderrechte": "Diritti esclusivi",
  "Speichern": "Risparmiare",
  "Sprache": "Lingua",
  "Stammgrundstueck": "Fondo di base",
  "Stammperson": "Persona base",
  "StammpersonImGrundbuch": "Progenitore nel registro fondiario",
  "StandardSuche": "Ricerca standard",
  "Standardrechtbelastungen": "Carichi legali standard",
  "StandardrechteIdsAufbereiten_DI_GL_SDR_VO_AN": "Preparare gli ID dei diritti standard (DI, GL, SDR, VO, AN)",
  "Standardsuche": " Ricerca standard",
  "Startdatum": "Data di inizio",
  "Status": "Stato",
  "StehtAufFolgendenGrundstuecken": "Si basa sulle seguenti proprietà",
  "Steuerjahr": "Anno fiscale",
  "Stichwort": "Parola chiave",
  "StichwortOderAblaufdatum": "Data di scadenza/Parola chiave",
  "Stichwortzusatz": "Parola chiave integratore",
  "Stockwerk": "Piano",
  "Stockwerkeigentum": "Proprietà per piani",
  "Strasse": "Via",
  "StrasseBenanntesGebiet": "Via / area denominata",
  "StrasseHausNr": "Via / N.",
  "StrasseOderFlurnameHausnummer": "Via, casa n.",
  "StrasseOderHausnummer": "Via/numero civico",
  "Suche": "Ricerca",
  "Suchergebnis": "Risultato della ricerca",
  "TAGEBUCH": "Giornale",
  "TAGEBUCH_ABGESCHLOSSEN": "Giornale terminato",
  "TEILPFANDRECHT": "Diritto di pegno parziale",
  "TEILPFANDRECHT_KURZ": "P",
  "TIEFBAU": "Ingegneria civile",
  "TOPOMAPS": "",
  "Tag": "Giorno",
  "Tagebuchnummer": "N° giornale",
  "Tagebuchstatus": "Stato del giornale",
  "Teilbetrag": "Importo parziale",
  "TeilbetragGruppe": "Gruppo di importo parziale",
  "Teilflaeche": "Superficie parziale",
  "Template": "Modello",
  "TiteleingangGrundbuch": "Iscrizione al registro fondiario dei titoli di proprietà",
  "Today": "Oggi",
  "TodesdatumLiquidationsdatuminaktivSeit": "Data del decesso / data della liquidazione / inattivo dal",
  "Totalflaeche": "Area totale",
  "Typ": "Tipo",
  "TypDerBauwerke": "Tipo di edificio",
  "UEBRIGEART_lang": "Altro",
  "UEBRIGER_STRASSENBAU_PARKPLAETZE": "Altre costruzioni stradali, parcheggi",
  "UEBRIGES_RECHT": "",
  "UEBRIGES_SPEZIALISIERTES_GESUNDHEITSWESEN": "Altre cure specializzate",
  "UEBRIGE_BAUTEN_IM_ZUSAMMENHANG_MIT_WOHNGEBAEUDEN": "Altri edifici in connessione con edifici residenziali",
  "UEBRIGE_BERECHTIGTE": "Altri aventi diritto",
  "UEBRIGE_ENTSORGUNGSANLAGEN": "Altri impianti di smaltimento",
  "UEBRIGE_INFRASTRUKTUR": "Altre infrastrutture",
  "UEBRIGE_VERKEHRSANLAGEN": "Altre strutture per il traffico",
  "UEBRIGE_VERSORGUNGSANLAGEN": "Altri servizi",
  "UEBRIGE_VERWENDUNG_FUER_WIRTSCHAFTLICHE_ZWECKE": "Altri usi a fini economici",
  "UFERVERBAUUNGEN_STAUDAEMME": "Argini, dighe",
  "UID": "IDI",
  "UID_STATUS": "Stato IDI",
  "UMBAU": "Conversione",
  "UNB": "SCON",
  "UNBEKANNT": "Sconosciuto",
  "UNBEKANNT_ausg": "Sconosciuto",
  "UNBESTIMMT": "Indefinito",
  "UNKULTIVIERTES_GEBIET_BISHER": "Area incolta",
  "UNTERGESCHOSS": "Seminterrato",
  "UNVERHEIRATET": "non sposato",
  "UebernahmeGrundstueckgewinnsteuer": "Übernahme Grundstückgewinnsteuer durch Erwerber",
  "UebrigeBerechtigte": "Altri aventi diritto",
  "UebrigeBerechtigungen": "Altre autorizzazioni",
  "UidBeiNatuerlichenPersonenDrucken": "IDI per le persone fisiche",
  "UidStatus": "Stato IDI",
  "Unterart": "Sotto-tipo",
  "Unterirdisch": "sotterraneo",
  "Url": "Url",
  "User menu": "Menu utente",
  "VEC": "VEC",
  "VEC_lang": "Chemin de fer",
  "VEGETATIONSLOS_ABBAU_DEPONIE": "Miniere, discariche",
  "VEGETATIONSLOS_FELS": "Roccia",
  "VEGETATIONSLOS_GEROELL_SAND": "Massi, sabbia",
  "VEGETATIONSLOS_GLETSCHER_FIRN": "Ghiacciaio, Abete",
  "VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE": "Area libera da vegetazione rimanente",
  "VERAEUSSERER": "Venditore",
  "VERHEIRATET": "Sposato",
  "VERIFIKATION": "Verifica",
  "VERKNUEPFT_MIT_GRUNDBUCH": "collegato con registro fondiario",
  "VERTRAGSART": "Tipo di contratto",
  "VERWALTERADRESSE": "Indirizzo Amministrazione",
  "VERWITWET": "Vedova",
  "VIC": "VIC",
  "VIC_lang": "Chemin vicinal",
  "VORBEHALTENERVORGANG": "[I] Vorbehaltener Vorgang",
  "VORMERKUNG": "Annotazione",
  "VORMERKUNG_KURZ": "AN",
  "VORPRUEFUNG": "Preesame",
  "ValidierungsFehler": "Errore durante la convalida: {{fehlerMeldung}}",
  "Veraeusserer": "Venditore",
  "Verarbeitungsart": "Tipo di trattamento",
  "Verarbeitungsstatus": "Stato del trattamento",
  "VerbindungZumServerNichtMöglich": "La connessione a Internet è interrotta. Provare ad aggiornare con F5 o controllare la connessione a Internet.",
  "VergleichMitZpvPerson": "Confronto con la persona ZPV",
  "VersicherungsNr": "Assicurazione no.",
  "VersicherungsNummerAbkürzung": "Versetto n.",
  "Versicherungsnummer": "Numero d'assicurazione",
  "Vertragsart": "Tipo di contratto",
  "Vertragstexte": "Testi di contratti",
  "VertragstexteAufbereiten": "Preparazione dei testi contrattuali",
  "VonAenderungenBetroffeneRubriken": "Rubriche interessate dalle modifiche :",
  "VoraussichtlicheBaudauer": "Durata prevista della costruzione",
  "Vormerkung": "Annotazione",
  "Vormerkungen": "Annotazioni",
  "Vorname": "Nome",
  "Vorname/Bezeichnung2": "Nome/designazione 2",
  "WALD_BISHER": "Foresta",
  "WARTEN_AUF_VORGAENGER": "In attesa dell'iscrizione precedente",
  "WASSERENTSORGUNGSANLAGEN": "Sistemi di smaltimento dell'acqua",
  "WASSERVERSORGUNGSANLAGEN": "Sistemi di approvvigionamento idrico",
  "WEIBLICH": "Femminile",
  "WEIDEN_BISHER": "Salici",
  "WEIDWALD_BISHER": "Weidwald",
  "WERKSTAETTEN_FABRIKGEBAEUDE": "Officine, edifici industriali",
  "WOECHENTLICH": "Settimanale",
  "WOHNADRESSE": "Indirizzo del domicilio",
  "WOHNGEBAEUDE_FUER_GEMEINSCHAFTEN": "Edifici residenziali per comunità",
  "WOHNGEBAEUDE_MIT_NEBENNUTZUNG_BAUERNHAEUSER": "Edifici residenziali con uso accessorio (comprese le case coloniche)",
  "WOHNHEIME_OHNE_PFLEGEDIENSTE_BETREUUNG": "Case residenziali senza servizi e/o assistenza infermieristica",
  "WYTWEIDE_UEBRIGE_BESTOCKTE": "Wytweide, altra area di stoccaggio",
  "Weiter": "Ulteriori",
  "WeitereBauprojektdaten": "Ulteriori dati sui progetti di costruzione",
  "WeitereRechtsgründeAufbereiten": "Preparare ulteriori titoli giuridici",
  "WeitereVornamen": "Altri nomi",
  "WenigerAnzeigen": "Mostra meno",
  "Wertquote": "Valore immobiliare (quota di valore)",
  "Wohnungen": "Appartamenti",
  "Wohnungsflaeche": "Spazio piatto",
  "Wohnungsnummer": "Numero piatto",
  "Wohnungsstatus": "Stato",
  "XML": "XML",
  "XML_HTML": "XML-HTML",
  "ZPV-person": "Persona ZPV",
  "ZPVNummer": "Numero GCP",
  "ZURUECKGEZOGEN": "Ritirato",
  "ZURUECKGEZOGEN_AUSGETRAGEN": "Ritirato e scaricato",
  "ZURUECK_ABGEWIESEN": "Rifiutato del registro fondiario",
  "ZURUECK_ZURUECKGEZOGEN": "Ritirato dal registro fondiario",
  "ZURUECK_ZUR_KORREKTUR": "Ritorno per correzione",
  "ZUSTELLADRESSE": "Indirizzo di consegna",
  "Zeilen": "Linee",
  "ZeitraumBis": "Periodo fino a",
  "ZeitraumVon": "Periodo da",
  "ZinsUndAbzahlungsbestimmungen": "Condizioni particolari di interessi e ammortamenti",
  "Zivilstand": "Stato civile",
  "ZuExportierendeGrundstuecke": "Terreno da esportare",
  "ZuGunsten": "a favore di",
  "ZuGunstenLasten": "OD",
  "ZuLasten": "a carico di",
  "ZuVieleRequests": "Sono state effettuate troppe richieste. Riprovi tra un minuto.",
  "ZuVieleRequestsHeute": "È stato raggiunto il numero di interrogazioni consentite per oggi. Riprovare domani",
  "Zuklappen": "chiudere",
  "Zurück": "Indietro",
  "ZurückZumInhalt": "Torna al contenuto",
  "Zurücksetzen": "Reset",
  "Zusatzangaben": "Dati supplementari",
  "Zustand": "Stato",
  "actionbar.reset": "Reset",
  "actionbar.search": "Ricerca",
  "aktenempfaenger": "Destinatario degli atti",
  "aktualisierungsdatum": "Data di aggiornamento",
  "alte-grunbbuchmeldungen.datenbestandBisUndMit": "Il set di dati contiene i rapporti fino al 30 settembre 2009 incluso.",
  "alte-grundbuchmeldung.ListTitel": "Trovato vecchi messaggi",
  "alte-grundbuchmeldung.SucheTitel": "Ricerca di vecchi messaggi",
  "altegrundbuchmeldung.search.breadcrumb": "Notifica del vecchio registro fondiario",
  "amtlicheBewertung": "Valutazione ufficiale",
  "an": "a ",
  "anonymous": "anonimo",
  "anschrift": "Indirizzo",
  "atLeast2Letters": "Sono richiesti almeno due caratteri.",
  "auf": "su",
  "auftrag.ListTitel": "Mandati trovati",
  "auftraggeber": "Mandante",
  "auftragsTyp": "tipo di ordine",
  "auszugAmtlicheBewertungComponent": "Valutazione ufficiale",
  "auszugAnmerkungenComponent": "Menzioni",
  "auszugDienstbarkeitenComponent": "Servitù",
  "auszugDienstbarkeitenPlaceHolderComponent": "Servitù",
  "auszugDominierteGrundstueckeComponent": "Fondi serventi",
  "auszugEigentumComponent": "Proprietà",
  "auszugGemeindeGrundstueckComponent": "Informazioni sulla comune",
  "auszugGrundbuchUebersichtComponent": "Panoramica del registro fondiario",
  "auszugGrundbuchUebersichtMiteigentumComponent": "Panoramica del registro fondiario delle comproprietà",
  "auszugGrundbuchUebersichtStockwerkComponent": "Panoramica del registro fondiario dei condomini",
  "auszugGrundbuchVertragstexteComponent": "Testi di contratti",
  "auszugGrundlastenComponent": "Oneri fondiari",
  "auszugGrundstueckBeschreibungLiegenschaftComponent": "Descrizione del fondo",
  "auszugGrundstueckBeschreibungMiteigentumComponent": "Descrizione del fondo",
  "auszugGrundstueckBeschreibungSDRComponent": "Descrizione del fondo",
  "auszugGrundstueckBeschreibungStockwerkComponent": "Descrizione del fondo",
  "auszugGwrComponent": "estrattoGwrComponente",
  "auszugHaengigeGeschaefteGrundbuchComponent": "Iscrizioni pendenti",
  "auszugOerebComponent": "PLR-cadastre",
  "auszugOerebPlaceHolderComponent": "PLR-cadastre",
  "auszugPfandrechteComponent": "Diritti di pegno",
  "auszugRangregelungenComponent": "Regolamentazione del rango",
  "auszugSeybuchAlpgrundstueckeComponent": "Proprietà dell'alpe",
  "auszugSeybuchGrundbuchDaten": "Dati del registro fondiario dell'Alpe",
  "auszugSeybuchGrundstueckBeschreibung": "Descrizione del fondo",
  "auszugVermessungUebersichtLiegenschaftComponent": "Panoramica della proprietà",
  "auszugVermessungUebersichtSDRComponent": "Panoramica del sondaggio SDR",
  "auszugVormerkungenComponent": "Annotazioni",
  "avMutationsNummer": "Numero di mutazioni",
  "backToIntercapi": "Torna a {{name}}",
  "batch.auftrag.delete.message": "l'ordine",
  "batchauftrag.detail.Titel": "Lavoro batch: ",
  "bearbeitetstatusHeading": "Stato di elaborazione",
  "belegeZu": "Prove per ",
  "berechtigtePersonen": "persone autorizzate",
  "bfsNummer": "Numro UST",
  "bis": "fino al",
  "breadcrumbauskunftgrundbuchmeldung": "Avvisi del registro fondiario",
  "breadcrumbauskunftgrundbuchmeldunglist": "Risultato della ricerca",
  "cantSearchAlone": "Questo campo non può essere cercato da solo",
  "cmisModal.fensterSchliessen": "Chiudere la finestra",
  "component.tablewrapper.nichtVollstaendigGeladen": "Attenzione, non tutti i dati sono caricati.",
  "component.tablewrapper.resume": "Pratica",
  "component.tablewrapper.suspend": "Pausa",
  "configuration.actions": "Azioni",
  "configuration.cancel": "Annulla",
  "configuration.deutscherLink": "URL IT",
  "configuration.deutscherName": "Nome IT",
  "configuration.download": "Scaricare",
  "configuration.dropZone": "Zona di caduta",
  "configuration.fileAuswaehlen": "Selezionare il file",
  "configuration.franzoesischerLink": "URL FR",
  "configuration.franzoesischerName": "Nome FR",
  "configuration.konfigurationDerAnsicht": "Visualizza la configurazione",
  "configuration.konfigurationHeraufladen": "Caricare la configurazione",
  "configuration.konfigurationHerunterladen": "Scarica la configurazione",
  "configuration.konfigurationVerwalten": "Gestire la configurazione",
  "configuration.linksImMenuUnterstuetzung": "Collegamenti nel menu Informazioni",
  "configuration.linksImMenuUnterstuetzungPublic": "Link nel menu Informazioni (Intercapi-Public)",
  "configuration.name": "Nome",
  "configuration.position": "Posizione",
  "configuration.progress": "Progressi",
  "configuration.queueLength": "Lunghezza",
  "configuration.reihenfolgeGrundstueckdetail": "Dettaglio del diagramma di sequenza",
  "configuration.reihenfolgePfandrechtdetail": "Dettaglio del diritto di pegno di sequenza",
  "configuration.reihenfolgeStandardrechtdetail": "Ordine Standard Dettaglio destro",
  "configuration.remove": "Rimuovere",
  "configuration.size": "Dimensione",
  "configuration.status": "Stato",
  "configuration.titel": "Titolo",
  "configuration.upload": "Caricare",
  "configuration.uploadQueue": "Coda",
  "core.navigation.abmelden": "Chiudere la sessione",
  "core.navigation.altegrundbuchmeldung": "Notifica del vecchio registro fondiario",
  "core.navigation.amtlicheBewertung": "Valutazione ufficiale",
  "core.navigation.berechtigtePersonen": "Persone avente",
  "core.navigation.ech0134.empfaenger": "Destinatario degli avvisi eCH",
  "core.navigation.ech0134.grundbuchmeldungen": "Avvisi del registro fondiario eCH",
  "core.navigation.erweitertesSuchregister": "Elenco dei proprietari BE",
  "core.navigation.gebaeude": "Edificio",
  "core.navigation.gebaeudeUndWohnungsregister": "Registro edifici e abitazioni (REA)",
  "core.navigation.gemeindeGemeindekreis": "Comune / Sottocircolo",
  "core.navigation.geometergeschaeft": "Pratica del geometra",
  "core.navigation.glossar": "Glossario",
  "core.navigation.grundbuch": "Registro fondiario",
  "core.navigation.grundbuchgeschaeft": "Iscrizioni a giornale",
  "core.navigation.grundbuchmeldung": "Avvisi del registro fondiario",
  "core.navigation.grundstueck": "Fondo",
  "core.navigation.gwrBauprojekte": "Progetti di costruzione REA",
  "core.navigation.gwrGebaeude": "Edificio REA",
  "core.navigation.home": "Pagina iniziale",
  "core.navigation.importExport": "Importazione / Esportazione",
  "core.navigation.impressumRechtliches": "Stampa e note legali",
  "core.navigation.konfiguration": "Configurazione",
  "core.navigation.meineGrundstueckePublic": "I miei edifici",
  "core.navigation.meineGrundstueckePublic.identifizierungsStufeUnzureichend": "Non si dispone del livello di identificazione necessario per visualizzare i dati.",
  "core.navigation.meineGrundstueckePublic.stepUpRegistrierung": "Si prega di registrarsi per",
  "core.navigation.meineGrundstueckePublic.stepUpRegistrierungLinkText": "Migliora il livello di identificazione",
  "core.navigation.neskoab": "NESKOAB",
  "core.navigation.publikation": "Pubblicazioni",
  "core.navigation.rechte": "Diritti",
  "core.navigation.stammdaten": "Dati di base",
  "core.navigation.stammpersonen": "Persona base",
  "core.navigation.system": "Sistema",
  "core.navigation.unterstuetzung": "Informazione",
  "core.navigation.unterstuetzungPublic": "Informazione",
  "core.navigation.vermessung": "Misurazione",
  "dashboard.rechtehinweis.legalHintComment": "Solo gli estratti certificati del registro rilasciati dall'ufficio competente o dall'autorità competente sono vincolanti.",
  "dashboard.rechtehinweis.legalHintComment1": " ",
  "dashboard.rechtehinweis.legalHintHeader": "Nota: validità legale dei dati",
  "dashboard.rechtehinweis.legalHintMessage": "I dati e i riferimenti presentati sono senza garanzia e non hanno alcun effetto legale.",
  "datenexport.BODENBEDECKUNGSFILTER": "Esportazione di parcelle standard - filtro copertura del suolo",
  "datenexport.EIGENTUEMERART": "Esportazione di proprietà standard - tipo di proprietario",
  "datenexport.EIGENTUEMERLISTE": "Esportazione di proprietà standard - Elenco dei proprietari",
  "datenexport.EIGENTUEMERREGISTER": "Esportazione di proprietà standard - registro dei proprietari",
  "datenexport.GEAENDERTEBODENBEDGS": "Esportazione di parcelle standard - parcelle modificate con restrizione alla copertura del suolo",
  "datenexport.GEAENDERTEGS": "Esportazione di trame standard - trame modificate",
  "datenexport.GEBAEUDELISTE": "Esportazione di proprietà standard - Elenco edifici",
  "datenexport.GELAN": "GELAN",
  "datenexport.GELOESCHTBODENBEDGS": "Esportazione di parcelle standard - parcelle cancellate con restrizione della copertura del suolo",
  "datenexport.GELOESCHTEGS": "Esportazione di proprietà standard - proprietà eliminate",
  "datenexport.GRUNDSTUECKLISTE": "Esportazione di proprietà standard - Elenco di proprietà",
  "datenexport.RECHTEREGISTER": "Registro diritti",
  "datenexport.STANDARD": "Esportazione di proprietà standard",
  "datenexport.auftrag": "Mandato",
  "datenexport.auftragstitelUndBeschreibung": "Titolo e descrizione dell'ordine",
  "datenexport.ausfuehrungsdatum": "Data di esecuzione",
  "datenexport.auswahlAuftragsexportTemplate": "Selezione del modello del tipo di ordine",
  "datenexport.auswahlAuftragsoptionen": "Selezione delle opzioni d'ordine",
  "datenexport.auswahlAuftragsoptionen_readonly": "Opzioni d'ordine selezionate",
  "datenexport.auswahlAuftragstyp": "Selezione del tipo di ordine",
  "datenexport.auswahlAuftragstyp_readonly": "Tipo di mandato selezionato",
  "datenexport.auswahlBetroffenerDatenbestand": "Selezione del set di dati interessati",
  "datenexport.auswahlBetroffenerDatenbestand_readonly": "Set di dati selezionati",
  "datenexport.auswahlErgebnisoptionen": "Selezione delle opzioni di risultato",
  "datenexport.auswahlErgebnisoptionen_readonly": "Opzioni di risultato selezionate",
  "datenexport.beschreibung": "Descrizione",
  "datenexport.detailsZumAuftraggeber": "Dettagli sul cliente",
  "datenexport.email1": "Email 1",
  "datenexport.email2": "Email 2",
  "datenexport.email3": "Email 3",
  "datenexport.format": "Formato",
  "datenexport.informationAnFolgendeEmpfaenger": "Informazioni ai seguenti destinatari (max. 3)",
  "datenexport.periodizitaet": "Periodicità",
  "datenexport.periodizitaetValues": "dataexport.periodizitaetValues",
  "datenexport.prioritaet": "Priorità",
  "datenexport.prioritaetValues": "dataexport.priorityValues",
  "datenexport.stapelverarbeitungsauftragErstellen": "Creare un lavoro batch",
  "datenexport.titel": "Titolo",
  "delete.check.modal.body": "Vuoi davvero cancellare '{{entity}}'?",
  "delete.check.modal.title": "Cancellare",
  "detailGrundstueckAnmerkungen": "Menzioni",
  "detailGrundstueckBeschreibung": "Descrizione del fondo",
  "detailGrundstueckDienstbarkeiten": "Servitù",
  "detailGrundstueckEigentum": "Proprietà",
  "detailGrundstueckGeschaefteAuftraege": "Pratiche / Mandati",
  "detailGrundstueckGrundlasten": "Oneri fondiari",
  "detailGrundstueckGrundpfandrechte": "Diritti di pegno",
  "detailGrundstueckRangregelungen": "Regolamentazione del rango",
  "detailGrundstueckVormerkungen": "Annotazioni",
  "detailPfandrechtBelastungen": "Carichi",
  "detailPfandrechtGlaeubiger": "Creditore",
  "detailPfandrechtHaengigeGeschaefte": "Iscrizioni pendenti",
  "detailPfandrechtKopfdaten": "Dati di testa",
  "detailPfandrechtPerimeter": "Perimetro",
  "detailPfandrechtPfandtitel": "Titolo di pegno",
  "detailPfandrechtSchuldner": "Debitore",
  "detailStandardrechtBelastungen": "Carichi",
  "detailStandardrechtHaengigeGeschaefte": "Iscrizioni pendenti",
  "detailStandardrechtKopfdaten": "Dati di testa",
  "detailStandardrechtPerimeter": "Perimetro",
  "detailsGemeindeGb": "Mostra i dettagli di Gemeinde {{name}}",
  "detailsGeometerGeschäft": "Mostra i dettagli della pratica del geometra",
  "detailsGeschäft": "Mostra i dettagli della pratica",
  "detailsGrundstueck": "Dettagli sulla proprietà {{nummer}}",
  "detailsMutationAnzeigen": "Mostra i dettagli delle mutazioni AV",
  "dirty.check.modal.body": "Vuoi davvero lasciare il sito?",
  "dirty.check.modal.title": "Dati non salvati",
  "dokulinkModal.fensterSchliessen": "Chiudere la finestra",
  "durch": "attraverso",
  "eBelege": "Documenti",
  "ech0134.grundbuchmeldung.list": "Avvisi del registro fondiario eCH trovati",
  "ech0134.grundbuchmeldungen.datumVersandBis": "Data di spedizione fino a",
  "ech0134.grundbuchmeldungen.datumVersandVon": "Data di spedizione da",
  "ech0134.grundbuchmeldungen.delete": "Cancellare i avvisi del registro fondiario eCH",
  "ech0134.grundbuchmeldungen.empfaenger": "Destinatario degli avvisi eCH",
  "ech0134.grundbuchmeldungen.reset.message": "Messaggio del registro fondiario eCH {{geschaeftsnummer}} al destinatario {{sedexId}}",
  "ech0134.grundbuchmeldungen.status": "Stato del messaggio",
  "ech0134.grundbuchmeldungen.suche": "Ricerca dei avvisi del registro fondiario eCH",
  "ech0134.grundbuchmeldungen.title": "Avvisi del registro fondiario eCH",
  "egbpid.gehoertZuStammperson": "L'EGBPID inserito appartiene alla seguente persona principale:",
  "egbpid.navigationTitel": "Mostra la persona di base",
  "egbpid.stammpersonAnzeigen": "Si vuole visualizzare la persona principale?",
  "eigentuemerAdressliste.egridList": "",
  "eigentuemerAdressliste.eigentuemerAdressliste": "",
  "eigentuemerAdressliste.infoEigentuemerAdressliste": "",
  "eigentuemerAdressliste.infoKommaTrennung": "",
  "eigentuemerAdressliste.infoMizen": "",
  "eigentuemerAdressliste.listeErstellen": "",
  "eigentuemerAdressliste.mizen": "",
  "eigentumImGrundbuch": "Proprietà nel registro fondiario",
  "eigentumanteil.anteilUnbekannt": "Condividi sconosciuto",
  "eigentumanteil.unbekannt": "Sconosciuto",
  "eintragungAmtlicheBewertung": "Voci della valutazione ufficiale",
  "elasticsearch.options": "Opzioni di ricerca",
  "email": "E-Mail",
  "erweitern": "espandere",
  "erweitertesSuchregister.MitGebaeude": "Con edifici",
  "erweitertesSuchregister.infoMessage": "Crea un elenco di fondo per le quali il Cantone di Berna è registrato come proprietario. La creazione può richiedere alcuni minuti.",
  "externeGemeinde": "Comune esterna",
  "false": "No",
  "forbidden.text": "Non si può beneficiare della seguente azione.",
  "forbidden.title": "Accesso negato",
  "functionbar.back": "Indietro",
  "functionbar.cancel": "Annulla",
  "functionbar.continue": "Continua",
  "functionbar.delete": "Cancellare",
  "functionbar.edit": "Modifica",
  "functionbar.new": "Nuovo",
  "functionbar.save": "Risparmiare",
  "gebaeude.BE-GID": "BE-GID",
  "gebaeude.BreadcrumbSuche": "Edificio",
  "gebaeude.Egid": "EGID",
  "gebaeude.EgidKantGid": "EGID / Kant-GID",
  "gebaeude.KantonalerGid": "GID cantonale",
  "gebaeude.SucheTitel": "Ricerca di edifici",
  "gebaeude.gehoertZuSDR": "appartiene a DSP",
  "gebaeudeart": "Tipo di edificio",
  "gebauede.gehoertZuSDR": "appartiene a DSP",
  "geburtsdatumInZukunft": "La data di nascita è nel futuro.",
  "gebäudeeingangHeading": "Ingresso dell'edificio",
  "gefundeneGemeinden": "Comune trovate",
  "gefundeneGeometergeschaefte": "Pratiche del geometra trovati",
  "gefundeneGrundbuchgeschaefte": "Pratiche del registro fondiario trovate",
  "gegeneintraegeDITDienstbarkeitenDrucken": "Stampare le controiscrizioni delle servitù (DI/T)",
  "gehoertZu": "appartiene a",
  "gehoertZuFolgenderPolitischerGemeinde": "Appartiene al seguente comune politico",
  "gehoertZuGrundstueck": "Appartiene alla seguente proprietà",
  "gemaessAmtlicherBewertung": "Secondo la valutazione ufficiale",
  "gemaessGrundbuch": "Secondo il registro fondiario",
  "gemaessZPV": "Secondo ZPV",
  "gemeinde.SucheTitel": "Ricerca dei comuni",
  "gemeinde.bfs": "Numero BfS",
  "gemeinde.breadcumbSuche": "Comune / Sottocircolo",
  "gemeinde.kreis": "Numero del sottocircolo",
  "gemeinde.name": "Nome",
  "geometrischAuf": "geometricamente su",
  "glaeubiger": "Creditore",
  "grundbuchmeldung.SucheTitel": "Ricerca di notifiche del registro fondiario",
  "grundbuchmeldung.datummeldung": "Data di spedizione",
  "grundbuchmeldung.download": "Scarica i messaggi",
  "grundbuchmeldung.empfaenger.bezeichnung": "Designazione del ricevitore",
  "grundbuchmeldung.meldungsstatus": "Stato del messaggio",
  "grundbuchmeldung.meldungsstatus.ERSTELLT": "Creato",
  "grundbuchmeldung.meldungsstatus.FEHLERHAFT_ERSTELLT": "Creato in modo non corretto",
  "grundbuchmeldung.meldungsstatus.FEHLERHAFT_GESENDET": "Inviato difettoso",
  "grundbuchmeldung.meldungsstatus.GESENDET": "Inviato",
  "grundbuchmeldung.meldungsstatus.NICHT_ERSTELLT": "Non creato",
  "grundbuchmeldung.reset": "Azzeramento della spedizione",
  "grundbuchmeldung.search.breadcrumb": "Avvisi del registro fondiario",
  "grundbuchmeldung.suche": "Ricerca",
  "grundbuchmeldung.tooltip": "Mostra notifica del registro fondiario",
  "grundbuchmeldung_": "grundbuchmeldung_",
  "grundbuchmeldungen.ListTitel": "Notifiche del registro fondiario trovate",
  "grundstueck.ListTitel": "Fondi trovati",
  "grundstueck.SucheTitel": "Ricerca di fondi",
  "grundstueck.eigentum.Bemerkungen": "Osservazioni",
  "grundstueck.eigentum.DominierendesGrundstueck": "Fondo dominante",
  "grundstueck.eigentum.ExterneHinweise": "Indicazioni esterne",
  "grundstueck.rubrik.AlleDaten": "Tutti i dati della proprietà",
  "grundstueck.rubrik.Anmerkungen": "Menzioni",
  "grundstueck.rubrik.BeschreibendeDaten": "Descrizione del fondo",
  "grundstueck.rubrik.Dienstbarkeiten": "Servitù",
  "grundstueck.rubrik.Eigentum": "Proprietà",
  "grundstueck.rubrik.Grundlasten": "Oneri fondiari",
  "grundstueck.rubrik.Grundpfandrechte": "Diritti di pegno",
  "grundstueck.rubrik.Grundstueckbeschreibung": "Descrizione del fondo",
  "grundstueck.rubrik.HaengigeGeschaefte": "Iscrizioni",
  "grundstueck.rubrik.OeffentlicheAnmerkungen": "Commenti del pubblico",
  "grundstueck.rubrik.Oereb": "PLR-cadastre",
  "grundstueck.rubrik.Rangregelung": "Regolamentazione del rango",
  "grundstueck.rubrik.Vormerkungen": "Annotazioni",
  "grundstueck.search.breadcrumb": "Registro fondi",
  "grundstueck.subnav.Anmerkungen": "Menzioni",
  "grundstueck.subnav.BeschreibendeDaten": "Dati descrittivi",
  "grundstueck.subnav.Dienstbarkeiten": "Servitù",
  "grundstueck.subnav.Eigentum": "Proprietà",
  "grundstueck.subnav.GrundbuchVermessung": "Registro fondiario/sondaggio",
  "grundstueck.subnav.Grundlasten": "Oneri fondiari",
  "grundstueck.subnav.Grundpfandrechte": "Diritti di pegno",
  "grundstueck.subnav.GwrObjekte": "Registro degli edifici e delle abitazioni",
  "grundstueck.subnav.HaengigeGeschaefte": "Iscrizioni",
  "grundstueck.subnav.OerebKataster": "PLR-cadastre",
  "grundstueck.subnav.Rangregelungen": "Regolamentazione del rango",
  "grundstueck.subnav.Uebersicht": "Visione di insieme",
  "grundstueck.subnav.Vormerkungen": "Annotazioni",
  "grundstueck.subnav.neskoab": "Valutazione ufficiale esterna",
  "grundstueckHeading": "Registro fondi",
  "grundstueckflaeche": "Superficie del fondo",
  "gueltig": "Valido",
  "gwr-link.tooltip": "Mostra dettagli su  EGID {{egid}} in REA",
  "gwr.EingabeMussGueltigeStrasseSein": "La via può contenere un massimo di 60 caratteri",
  "gwrBauprojekt.BreadcrumbSuche": "Progetto di costruzione REA",
  "gwrBauprojekt.SucheTitel": "Ricerca dei progetti di costruzione della REA",
  "gwrGebaeude.BreadcrumbSuche": "Edificio REA",
  "gwrGebaeude.SucheTitel": "Ricerca degli edifici REA",
  "gültigAbSteuerjahr": "Valido dall'anno fiscale",
  "handelsangabenZu": "Dati commerciali su",
  "historisiert": "Storicizzato",
  "illegalObjectState": "Stato dell'oggetto illegale",
  "imNachgangZu": "postergato a:",
  "inbox.new-message": "Nella casella di posta sono presenti messaggi non letti",
  "inbox.notification.title": "Aprire il messaggio in una nuova finestra",
  "inbox.open": "Aprire la casella di posta",
  "inbox.open.title": "Aprire la casella di posta elettronica in una nuova finestra",
  "inbox.title": "Postale",
  "invalidrequest.title": "Richiesta non valida",
  "kanton": "Cantone",
  "kompakt": "compatto",
  "kreisNummer": "Numero del sottocircolo",
  "kuerzel": "Abbreviazione",
  "layouts.GeschichteEinAus": "Cronologia on/off",
  "layouts.emailAendern": "Cambia e-mail",
  "layouts.entwicklungsUmgebung": "Ambiente di sviluppo",
  "layouts.notAutorizedTitle": "Autorizzazione fallita: l'utente registrato non è autorizzato in {{appTitle}}.",
  "layouts.page.title": "Intercapi",
  "layouts.page.titleNavigation": "Navigazione Intercapi",
  "layouts.passwortAendern": "Cambia password",
  "layouts.settings": "Impostazioni",
  "layouts.testUmgebung": "Ambiente di prova",
  "layouts.toolbar.de": "IT",
  "layouts.toolbar.fr": "FR",
  "maps.anzeigePlan": "Piano di visualizzazione",
  "maps.anzeigePlanZu": "Piano di visualizzazione per",
  "maps.exception.errorPageTitle": "Errore durante il richiamo della mappa nel sistema esterno {{fremdsystem}}.",
  "maps.exception.geo_link.allGrundstueckeNotFound": "Le parcelle che state cercando non possono essere visualizzate nella planimetria al momento.",
  "maps.exception.geo_link.authorizationFailed": "Non sei autorizzato a visualizzare questa mappa. Effettuare il login a Grudis.",
  "maps.exception.geo_link.errorMessage": "Si è verificato un errore tecnico. Purtroppo la mappa non può essere visualizzata.",
  "maps.exception.geo_link.gemeindeNotFound": "Al momento non è possibile visualizzare il comune/quartiere del registro fondiario nella planimetria.",
  "maps.exception.geo_link.grundstueckNotFound": "La proprietà ricercata non può essere visualizzata nella planimetria. Non sono disponibili dati geometrici digitali. Si desidera visualizzare la planimetria del comune/del distretto del registro fondiario?",
  "maps.exception.geo_link.invalidRequest": "La chiamata alla mappa non è valida. Se il problema si ripete, contattare l'amministratore.",
  "maps.exception.topomaps.authorizationFailed": "",
  "maps.exception.topomaps.errorMessage": "",
  "maps.exception.topomaps.invalidRequest": "",
  "mehrereNachfuehrungsgeometer": "Per questo comune sono registrati diversi geometri, ma solo uno può essere visualizzato.",
  "meinGrundstueck.tooltip": "",
  "meineGrundstuecke.filter": "",
  "meineGrundstuecke.titel": "",
  "meldungAbschlussdatumHeading": "Data di completamento (effetto legale)",
  "meldungEingangsdatumHeading": "Data del giornale di ricevimento",
  "meldungErwerberVeraeussererHeading": "Soggetto acquirente / Soggetto cedente",
  "meldungGebaeudeHeading": "Edificio",
  "meldungsempfaenger.bezeichnung": "Denominazione",
  "meldungsempfaenger.bezeichnung.invalid": "La designazione non deve essere vuota.",
  "meldungsempfaenger.detail": "Destinatario degli avvisi eCH",
  "meldungsempfaenger.ereignisse": "Riceve solo i seguenti eventi",
  "meldungsempfaenger.ereignisse.AENDERUNG_ANMERKUNG": "Nota di variazione",
  "meldungsempfaenger.ereignisse.AENDERUNG_DIENSTBARKEIT": "Emendamento servitù",
  "meldungsempfaenger.ereignisse.AENDERUNG_EIGENTUM": "Variazione della parte di proprietà",
  "meldungsempfaenger.ereignisse.AENDERUNG_GRUNDLAST": "Modifica del onere fondiario",
  "meldungsempfaenger.ereignisse.AENDERUNG_LIG_SDR": "Cambio di cuccetta o SDR",
  "meldungsempfaenger.ereignisse.AENDERUNG_PFANDRECHT": "Modifica del pegno su beni immobili",
  "meldungsempfaenger.ereignisse.AENDERUNG_STW_MIT": "Variazione della quota di comproprietà",
  "meldungsempfaenger.ereignisse.AENDERUNG_VORMERKUNG": "Modifica dell'annotazione",
  "meldungsempfaenger.ereignisse.LOESCHUNG_ANMERKUNG": "Nota di cancellazione",
  "meldungsempfaenger.ereignisse.LOESCHUNG_DIENSTBARKEIT": "Servitù di cancellazione",
  "meldungsempfaenger.ereignisse.LOESCHUNG_EIGENTUM": "Annullamento della parte di proprietà",
  "meldungsempfaenger.ereignisse.LOESCHUNG_GRUNDLAST": "Eliminazione onere fondiario",
  "meldungsempfaenger.ereignisse.LOESCHUNG_LIG_SDR": "Cancellazione di proprietà o SDR",
  "meldungsempfaenger.ereignisse.LOESCHUNG_PFANDRECHT": "Cancellazione del pegno immobiliare",
  "meldungsempfaenger.ereignisse.LOESCHUNG_STW_MIT": "Annullamento della quota di comproprietà",
  "meldungsempfaenger.ereignisse.LOESCHUNG_VORMERKUNG": "Cancellazione dell'annotazione",
  "meldungsempfaenger.ereignisse.NEU_ANMERKUNG": "Nuova menzione",
  "meldungsempfaenger.ereignisse.NEU_DIENSTBARKEIT": "Nuova servitù",
  "meldungsempfaenger.ereignisse.NEU_EIGENTUM": "Nuova parte di proprietà",
  "meldungsempfaenger.ereignisse.NEU_GRUNDLAST": "Nuovo onere fondiario",
  "meldungsempfaenger.ereignisse.NEU_LIG_SDR": "Nuova proprietà o SDR",
  "meldungsempfaenger.ereignisse.NEU_PFANDRECHT": "Nuovo pegno immobiliare",
  "meldungsempfaenger.ereignisse.NEU_STW_MIT": "Nuova quota di comproprietà",
  "meldungsempfaenger.ereignisse.NEU_VORMERKUNG": "Nuova annotazione",
  "meldungsempfaenger.erhaeltBaseDelivery": "Riceve in base alla consegna",
  "meldungsempfaenger.erhaeltVertraulicheDaten": "Preserva i dati riservati",
  "meldungsempfaenger.erhaeltmeldungen": "Riceve i messaggi",
  "meldungsempfaenger.error.uniqueConstraint": "Esiste già un destinatario di messaggio eCH con questo ID destinatario.",
  "meldungsempfaenger.gemeinde": "Limitato ai seguenti comuni",
  "meldungsempfaenger.hasMeldungen": "I messaggi sono di proprietà del destinatario. La cancellazione non è consentita.",
  "meldungsempfaenger.list": "Destinatari del messaggio eCH trovati",
  "meldungsempfaenger.sedexid": "ID destinatario Sedex",
  "meldungsempfaenger.sedexid.invalid": "L'ID destinatario Sedex non è valido",
  "meldungsempfaenger.suche": "Destinatario degli avvisi eCH",
  "modal.close": "Chiusura",
  "monat": "Mese",
  "monate": "Mesi",
  "navigation.grundbuchmeldung": "Mostra notifica del registro fondiario",
  "neskoab.AmtlicheBewertung": "Valutazione ufficiale",
  "neskoab.AmtlicherWert": "Valore ufficiale",
  "neskoab.AmtlicherWertCHF": "Valore ufficiale CHF",
  "neskoab.BasisRevision": "Revisione base",
  "neskoab.Eigentum/Verteiler": "Proprietario/distributore",
  "neskoab.EigentumVerteiler": "Proprietario/distributore",
  "neskoab.ErtragswertBGBB": "Valore aggiunto secondo BGBB",
  "neskoab.GueltigAbSteuerjahr": "Valido dall'anno fiscale",
  "neskoab.Mutationsdatum": "Data della mutazione",
  "neskoab.Mutationsgrund": "Motivo della mutazione",
  "neskoab.Nutzniesser": "Beneficiario",
  "neskoab.Nutzniessung": "Usufrutto",
  "neskoab.Objekte": "Oggetti",
  "neskoab.SucheTitel": "Ricerca di una legge speciale della Valutazione Ufficiale",
  "neskoab.Totalflaeche": "Area totale",
  "neskoab.nichtVerfuegbar": "Il servizio Nesko AB non è attualmente disponibile!",
  "neskoabSearch.search.breadcrumb": "NESKOAB",
  "nichtBearbeitet": "Non modificato",
  "nichtDefiniert": "Non definito",
  "not.authorized": "Nessuna autorizzazione",
  "notAutorizedLoginRedirect": "Effettuare nuovamente il login.",
  "notfount.title": "Nessun oggetto trovato.",
  "null": "null",
  "oereb.KeineInformationenVorhanden": "Nessuna informazione disponibile",
  "oereb.KeineOderNochKeineDatenVorhanden": "Nessun dato disponibile o non ancora disponibile",
  "oereb.auszugKompakt": "Estratto da PLR-cadastre (compatto)",
  "oereb.datenVonGrundstueck:": "Dati della proprietà genitore:",
  "oereb.nichtVerfuegbar": "Il servizio PLR-cadastre non è attualmente disponibile!",
  "oereb.oerebsBetreffenGrundstueck": "Restrizioni di diritto pubblico che interessano la proprietà",
  "oereb.oerebsBetreffenGrundstueckNicht": "Restrizioni di diritto pubblico sul titolo di proprietà che non incidono sull'immobile",
  "oereb.oerebsKeineDatenVorhanden": "Restrizioni di diritto pubblico alla proprietà fondiaria per le quali non sono ancora disponibili i dati",
  "ohneGrundbuchbezug": "Senza riferimento del registro fondiario",
  "optimistic-lock.modal.back": "No, indietro",
  "optimistic-lock.modal.body": "Il salvataggio non è possibile perché i dati sono stati modificati nel frattempo. Ricaricare i dati?",
  "optimistic-lock.modal.continue": "Sì, ricaricare",
  "optimistic-lock.modal.title": "Dati modificati",
  "person.SucheTitel": "Ricerca di persone autorizzate",
  "person.breadcrumbSuche": "Persone ammissibili",
  "personDiffHint": "Sono state trovate voci del registro fondiario con attributi diversi da quelli della persona principale.",
  "persongb.addresssperre": "Pubblicazione dell'indirizzo bloccato",
  "persongb.auskunftssperre": "Informazioni sulla persona bloccata",
  "personstamm.GrundbuchBezug": "Riferimento GB",
  "personstamm.ListTitel": "Trovati i clienti abituali",
  "personstamm.SucheTitel": "Ricerca di clienti abituali",
  "personstamm.ZPVNummer": "Numero GCP",
  "personstamm.search.breadcrumb": "Regolari",
  "personstamm.tab.ZPVSuche": "Ricerca ZPV",
  "projektiert": "progettato",
  "publikation.ListTitel": "Pubblicazioni trovate",
  "publikation.SucheTitel": "Ricerca di pubblicazioni",
  "publikation.search.breadcrumb": "Pubblicazioni",
  "publikation.suche": "Ricerca",
  "publikationAmtHeading": "Pratica del registro fondiario",
  "publikationDateHeading": "Data di pubblicazione",
  "recht.search.breadcrumb": "Diritti",
  "rechte.SucheTitel": "Ricerca dei diritti",
  "rechteId": "ID",
  "reset.check.modal.body": "Si vuole davvero resettare '{{entity}}'?",
  "reset.check.modal.title": "Reset",
  "rolle": "Ruolo",
  "saveSuccessMessage": "Le modifiche sono state salvate con successo.",
  "schnellsuche.help.attributes": "I criteri di ricerca inseriti vengono verificati in base ai seguenti attributi delle persone (a condizione che siano autorizzate):",
  "schnellsuche.help.city": "Codice postale, località, numero dell'edificio e sede legale solo in combinazione con altri criteri",
  "schnellsuche.help.exact": "I criteri di ricerca possono essere ulteriormente limitati da \"\". I campi in \"\" devono essere trovati esattamente. I seguenti campi possono essere ricercati esattamente.",
  "schnellsuche.help.exact.addition": "Esempio: Mira \"Modello\" \"Zurigo",
  "schnellsuche.help.fuzzy": "La ricerca rapida ignora i caratteri speciali e trova comunque nomi con grafie leggermente diverse. Le lettere maiuscole e minuscole vengono ignorate.",
  "schnellsuche.help.order": "I criteri di ricerca possono essere inseriti in qualsiasi ordine.",
  "schnellsuche.help.suche": "",
  "search.noResults": "Nessun risultato",
  "searchOhneProjektstatusZeitrahmenUndGrundstuecknummer": "Quando si effettua una ricerca con lo stato del progetto \"Tutti\", è necessario ricercare anche l'arco temporale o il numero fondo.",
  "searchZeitrahmenOhneVonOderBis": "Quando si effettua una ricerca con un intervallo di tempo, è necessario specificare le date di inizio e fine.",
  "searchZuVieleSuchkriterien": "Troppi criteri di ricerca sono stati specificati. Si prega di specificarne meno.",
  "searchZuWenigSuchkriterien": "I criteri di ricerca sono troppo imprecisi, si prega di specificarli.",
  "searchbar.nichtRegistriert": "Per utilizzare questa funzione è necessario collegarsi.",
  "searchbar.noResults": "Nessun lotto trovato",
  "searchbar.placeholderText": "Ricerca di fondi",
  "searchbar.searchingText": "Attendere prego ...",
  "searchperson.noResults": "Nessuna persona trovata",
  "searchperson.placeholderText": "Ricerca per persona",
  "searchperson.searchingText": "Attendere prego...",
  "security.actionUrl": "Azione",
  "security.adminHint": "Contattare l'amministratore.",
  "security.erweiterung": "Estensione",
  "security.kanton": "Cantone",
  "seit": "da",
  "select.all": "Seleziona tutti",
  "shared.breadcrumb.list": "Risultato della ricerca",
  "shared.logo.grundstueckInformationen": "Sistema informativo sui dati della proprietà",
  "stammperson-adresssperre": "Divulgazione dell'indirizzo bloccato",
  "stammperson-adresssperre-mitBerechtigung": "Divulgazione dell'indirizzo bloccata. Si prega di non trasmettere alcuna informazione.",
  "stammperson-auskunftsperre": "Informazioni personali bloccate.",
  "stammperson-auskunftsperre-mitBerechtigung": "Le informazioni sono bloccate. Si prega di non trasmettere alcuna informazione.",
  "stapelverarbeitung.search.breadcrumb": "Elaborazione in batch",
  "stichwortNichtVorhanden": "La ricerca per parola chiave non ha prodotto alcun risultato.",
  "stime.amtlicheBewertung": "Valutazione ufficiale",
  "stime.chf": "CHF",
  "stime.description": "Descrizione",
  "stime.flaeche": "Sedime (m²)",
  "stime.gebaeude": "Edifici",
  "stime.gesamtflaeche": "Superficie totale m²",
  "stime.gesamtwert": "Valore globale di stima",
  "stime.land": "Terreno",
  "stime.schaetzung": "Stima (CHF)",
  "stime.validfrom": "Stima calcolata il",
  "successfullyLoggedOut": "Il logout è avvenuto con successo",
  "suche.status": "Stato",
  "sucheNachGeometergeschäften": "Ricerca di pratiche del geometra",
  "sucheNachGrundbuchgeschäften": "Ricerca di pratiche",
  "suchergebnis.EIGENTUEMER": "Proprietari",
  "suchergebnis.GLAEUBIGER_SCHULDNER": "Creditori e debitori / debitori e debitori",
  "suchergebnis.UEBRIGE_BERECHTIGTE": "Altri aventi diritto",
  "suchergebnis.gemeinden.PolitischeGemeinde": "Comune politico",
  "telefax": "Fax",
  "telefonnummer1": "Numero di telefono1",
  "titel.detail.geometergeschaeft": "Pratica del geometra",
  "titel.zentralePerson": "Persona centrale",
  "title.AmtlicheBewertung": "Valutazione ufficiale",
  "title.AmtlicheVermessung": "Misurazione ufficiale",
  "title.Grundbuch": "Registro fondiario",
  "tooltip.EIGENTUEMER": "Proprietà del {{person}}",
  "tooltip.GLAEUBIGER_SCHULDNER": "Rapporti con i creditori {{person}}",
  "tooltip.UEBRIGE_BERECHTIGTE": "Tutti i permessi da {{person}}",
  "tooltip.detailsAuftrag": "Mostra i dettagli dell'ordine",
  "tooltip.detailsPersonGb": "Mostrare i dettagli della persona del registro fondiario.",
  "tooltip.detailsPersonStamm": "Mostra i dettagli della persona principale {{person}}.",
  "tooltip.detailsPersonZpv": "Mostra i dettagli della persona ZPV {{person}}.",
  "tooltip.meldungsempfaenger": "Mostra i dettagli del destinatario del messaggio",
  "tooltipHandelsangaben": "Mostra i dati commerciali",
  "tooltipZusatzangaben": "Mostra informazioni aggiuntive",
  "total": "Total",
  "true": "Sì",
  "uebersichtAmtlicheBewertungComponent": "Valutazione ufficiale",
  "uebersichtOerebPlaceHolderComponent": "PLR-cadastre",
  "uebrigeBerechtigungenImGrundbuch": "Altri diritti nel registro fondiario",
  "undefined": "sconosciuto",
  "ungueltigeXmlDateiHochgeladen": "Il file XML caricato non è valido.",
  "unscharfeSuche": "ricerca fuzzy",
  "unscharfeSucheTooltip": "I caratteri speciali/diacritici vengono ignorati in ogni caso, indipendentemente da questa opzione di ricerca.",
  "unsupported.text": "L'azione seguente non è supportata perché l'estensione richiesta non è attiva.",
  "unsupported.title": "Accesso non supportato",
  "unterirdisch": "sotterraneo",
  "vergleichGbPersonZpvPerson": "Confronto tra la persona del registro fondiario e la persona ZPV",
  "version": "Versione",
  "vertragsdaten.Eigentuemer": "Proprietario",
  "vertragsdaten.RechtsgrundArt": "Base giuridica",
  "vertragsdaten.RechtsgrundArt.ANDERE": "Altri",
  "vertragsdaten.RechtsgrundArt.GRENZAENDERUNG_SPEZIAL": "Modifiche dei confini Casi speciali",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_DRITTE": "Cambio di proprietà tra terzi",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_EHEGATTEN": "Cambio di proprietà tra coniugi",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_ERBEN": "Passaggio di proprietà a/tra gli eredi",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_GESELLSCHAFTEN": "Cambio di proprietà tra aziende",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_SPEZIAL": "Cambio di proprietà Casi speciali",
  "vertragsdaten.RechtsgrundArt.SONSTIGE_SPEZIAL": "Altri casi speciali",
  "vertragsdatensatz": "Set di dati del contratto",
  "vom": "del",
  "von": "di",
  "wurdeErfolgreichGeloescht": "è stato cancellato con successo",
  "wurdeErfolgreichGespeichert": "è stato salvato con successo",
  "zentraleNr": "Centrale no.",
  "zpv.MaximalResultWarning": "Risultato incompleto perché sono state trovate troppe voci. Si prega di restringere la ricerca.",
  "zpvService.nichtVerfuegbar": "Il servizio ZPV non è attualmente disponibile!",
  "zusatzangabenZuVeraeusserer": "Ulteriori informazioni sul venditore",
  "zustaendigerNachfuehrungsgeometer": "Geometra responsabile",
  "zustaendigesGrundbuchamt": "Registro fondiario competente",
  "{{label}} must be a valid date of the form 31.12.2018": "{{label}} deve essere una data corretta nel modulo 31.12.2018.",
  "{{label}} required": "{{label}} necessario",
  "ÄnderungOhneGeschäft": "Cambiamento senza business"
}
